// Global Variable
var intlTelInstance = {};

function vorwerkDemoStrings() {
  return window.theme?.strings?.demo || {};
}
function vorwerkConsultantStrings() {
  return window.theme?.strings?.consultant || {};
}
function vorwerkTaxStrings() {
  return window.theme?.strings?.taxInvoice || {};
}
function vorwerkCheckoutStrings() {
  return window.theme?.strings?.checkout || {};
}
function vorwerkStorepointWidgetStrings() {
    return window.theme?.strings?.storepointWidget || {};
}
function vorwerkGeneralStrings() {
  return window.theme?.strings?.general || {};
}
function vorwerkStep2aStrings() {
  return window.theme?.strings?.step2a || {};
}
function vwConfirmHtml(template, fallback, spanId) {
  const span = '<span id="' + spanId + '" class="fontWeight-9"></span>';
  const t = template || fallback;
  return '<p>' + t + ' ' + span + '</p>';
}

$(function() {
    validateExistingAdvisor();
    onloadTm4u();
    tablePaginate();
    toggleBodyScroll();
    enableAccountUpdateWhenFoundChanges();
    initMySwiper();
    initTextColumnsFlickity();
    if (!document.referrer.includes('choose-from-your-nearest-advisors')) {
        checkReferral();
    }
    setTimeout(() => {
        triggerMapPopup();
        bindFunction();
    }, 4500);
    if (window.location.pathname.includes('/account') || window.location.pathname.includes('/pages/newcomer-step-2') || window.location.pathname.includes('/pages/newcomer-owned')) {
      initIntlTelInput();
    }
    onloadInitFunctions();
    onloadGetAnchorLink();
    setTimeout(() => {
        eventListnerTriggerPopup();
    }, 4500);
    if (document.referrer.includes('register')) {
        onLoadLoader();
    }
    removeProfileUpdateError();
    toggleMegaMenuOverlay();
    // hoverATCbutton();

    if (window.theme.taxInvoice.is_tax_invoice_enabled && window.location.pathname.includes('/cart')) {
        getTaxAttr();
    }
    
    initStickyScrollIcon();
    initCollectionFilterCountPreservation();
})

const getCollectionFilterCountStorageKey = () => `collection-filter-counts:${window.location.pathname}`;

const readCollectionFilterCountCache = () => {
    try {
        return JSON.parse(sessionStorage.getItem(getCollectionFilterCountStorageKey()) || '{}');
    } catch (error) {
        return {};
    }
};

const writeCollectionFilterCountCache = (counts) => {
    try {
        sessionStorage.setItem(getCollectionFilterCountStorageKey(), JSON.stringify(counts));
    } catch (error) {
        // Ignore storage failures and keep default server-rendered counts.
    }
};

const getCollectionFilterCountKey = (input) => `${input.name}::${input.value}`;

const parseCollectionFilterCount = (countText) => {
    const parsed = parseInt(String(countText).replace(/[^\d]/g, ''), 10);
    return Number.isFinite(parsed) ? parsed : null;
};

const collectCollectionFilterCounts = (root = document) => {
    const counts = {};

    root.querySelectorAll('.filter-form .tag__input[name][value]').forEach((input) => {
        const label = input.closest('label');
        const countEl = label?.querySelector('[data-filter-count]');

        if (!countEl) {
            return;
        }

        const count = parseCollectionFilterCount(countEl.textContent);
        if (count === null) {
            return;
        }

        counts[getCollectionFilterCountKey(input)] = count;
    });

    return counts;
};

const mergeCollectionFilterCounts = (incomingCounts) => {
    const cachedCounts = readCollectionFilterCountCache();
    let changed = false;

    Object.entries(incomingCounts).forEach(([key, count]) => {
        if (!Number.isFinite(count)) {
            return;
        }

        if (cachedCounts[key] == null || count > cachedCounts[key]) {
            cachedCounts[key] = count;
            changed = true;
        }
    });

    if (changed) {
        writeCollectionFilterCountCache(cachedCounts);
    }

    return cachedCounts;
};

const applyCollectionFilterCounts = (counts, root = document) => {
    root.querySelectorAll('.filter-form .tag__input[name][value]').forEach((input) => {
        const label = input.closest('label');
        const countEl = label?.querySelector('[data-filter-count]');

        if (!countEl) {
            return;
        }

        const count = counts[getCollectionFilterCountKey(input)];
        if (!Number.isFinite(count)) {
            return;
        }

        countEl.textContent = `(${count})`;
    });
};

const initCollectionFilterCountPreservation = async () => {
    const filterForm = document.querySelector('.filter-form');
    if (!filterForm) {
        return;
    }

    let cachedCounts = mergeCollectionFilterCounts(collectCollectionFilterCounts(document));
    applyCollectionFilterCounts(cachedCounts, document);

    if (Object.keys(cachedCounts).length > 0) {
        return;
    }

    try {
        const response = await fetch(window.location.pathname, { credentials: 'same-origin' });
        if (!response.ok) {
            return;
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        cachedCounts = mergeCollectionFilterCounts(collectCollectionFilterCounts(doc));
        applyCollectionFilterCounts(cachedCounts, document);
    } catch (error) {
        // Ignore fetch failures and keep default server-rendered counts.
    }
};

document.addEventListener('collection:reloaded', () => {
    initCollectionFilterCountPreservation();
});

// Sticky Scroll to Top Icon functionality
function initStickyScrollIcon() {
    const stickyScrollSection = $('.jsc-sticky-scroll-section');
    
    if (!stickyScrollSection.length) {
        return;
    }
    const scrollThreshold = 300; 
    function toggleStickyIcon() {
        if (window.scrollY > scrollThreshold) {
            stickyScrollSection.addClass('show');
        } else {
            stickyScrollSection.removeClass('show');
        }
    }
        toggleStickyIcon();
        $(window).on('scroll', function() {
        toggleStickyIcon();
    });
    
    stickyScrollSection.on('click', function(e) {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
    stickyScrollSection.on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    });
}

const getGenericAlertElements = () => {
    const popup = $('#jsc-generic-alert');
    if (!popup.length) {
        return null;
    }

    return {
        popup,
        overlay: popup.find('.jsc-mixing-popup-overlay'),
        closeButton: popup.find('.jsc-mixing-popup-close'),
        confirmButton: popup.find('#jsc-generic-alert-confirm'),
        messageContainer: popup.find('#jsc-generic-alert-message')
    };
};

const showGenericAlert = (message, options = {}) => {
    const elements = getGenericAlertElements();
    const fallbackMessage = message == null ? '' : message;
    if (!elements) {
        window.alert(String(fallbackMessage));
        return;
    }

    const { confirmLabel = vorwerkGeneralStrings().ok || 'OK', onConfirm } = options;
    const normalizedMessage = Array.isArray(fallbackMessage)
        ? fallbackMessage.join('<br>')
        : String(fallbackMessage).replace(/\n/g, '<br>');

    elements.messageContainer.html(normalizedMessage);
    elements.confirmButton.text(confirmLabel);

    const closePopup = () => {
        elements.popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
        elements.confirmButton.off('click', handleConfirm);
        elements.closeButton.off('click', handleClose);
        elements.overlay.off('click', handleClose);
    };

    const handleClose = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        closePopup();
    };

    const handleConfirm = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (typeof onConfirm === 'function') {
            onConfirm();
        }
        closePopup();
    };

    elements.closeButton.off('click').on('click', handleClose);
    elements.overlay.off('click').on('click', handleClose);
    elements.confirmButton.off('click').on('click', handleConfirm);

    elements.popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    requestAnimationFrame(() => {
        elements.confirmButton.trigger('focus');
    });
};

window.showGenericAlert = showGenericAlert;

const isCustomerLoggedIn = () => {
    const customerInfo = window.theme && window.theme.customerInfo;
    if (!customerInfo) {
        return false;
    }
    const name = (customerInfo.name || '').trim();
    return name !== '' && name.toLowerCase() !== 'guest';
};

const showLoginRequiredPrompt = () => {
    const g = vorwerkGeneralStrings();
    const message = g.loginRequiredPurchase || 'To complete your purchase, please log in or set up an account first.';
    const baseLoginUrl = (window.theme && window.theme.routes && window.theme.routes.accountLogin) || '/account/login';
    const connector = baseLoginUrl.includes('?') ? '&' : '?';
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    const loginUrl = `${baseLoginUrl}${connector}return_url=${returnUrl}`;

    showGenericAlert(message, {
        confirmLabel: g.ok || 'OK',
        onConfirm: () => {
            window.location.href = loginUrl;
        }
    });
};

initMySwiper = () => {
    if (typeof Swiper === 'undefined') {
        return;
    }
    $('.swiper.mySwiper').each(function(index, element) {
        var _this = $(element);
        var autoplay = _this.data('autoplay');
        var autoplaySpeed = _this.data('autoplay-speed');

        var swiper_option = {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            initialSlide : 0
        }

        if (autoplay && autoplaySpeed != '') {
            swiper_option['autoplay'] = {
                delay: autoplaySpeed,
                disableOnInteraction: false
            }
        }
        var swiper = new Swiper(this, swiper_option);
    });
}

const onloadInitFunctions = () => {
    advisorRadioButtonHandling();
    getAdvisorLocalStorage();
    loadAdvisorName();
    // initAdvisorSelector();
};

loadAdvisorName = () =>{
    if ($('#jsc-cart-advisor-name').length) {
        var advisor_name = localStorage.getItem('Advisor Name');
        $('#jsc-cart-advisor-name').text(advisor_name);
        $('#jsc-cart-advisor-name-input').val(advisor_name);
    }
}

// Scripts for Advisor feature starts here
/**
 * HTML template for the advisor selection input field.
 * @type {string}
 */
function getSearchAdvisorFieldHtml() {
    const d = vorwerkDemoStrings();
    return `
    <div class="jsc-advisor m-t-15 relative">
        <p class="m-b-5">${d.pleaseEnterDemoCode || ''} <span style="color: red;">*</span></p>
        <input id="demo-code-input" type="text" value="" name="attributes[Demo Code]" class="advisor-text" style="width: 25ch;" placeholder="${d.enterDemoCodePlaceholder || ''}">
    </div>
`;
}
function getSearchAdvisorFieldNoDemoHtml() {
    const d = vorwerkDemoStrings();
    return `
    <div class="jsc-advisor m-t-15">
        <p class="m-b-5">${d.choosePreferredAdvisor || ''} <span style="color: red;">*</span></p>
        <p class="m-b-10" style="font-size: 0.9em;">
            <a href="${window.theme.urls.toStoreUrl('pages/store-locator')}" target="_blank" style="text-decoration: underline;">${d.findAdvisorNearYou || ''}</a>
        </p>
        <input id="search-advisor" type="text" value="" aria-label="${d.choosePreferredAdvisor || ''}" name="attributes[Advisor ID]" class="advisor-text full-width full-max-width" placeholder="${d.enterAdvisorNameOrId || ''}">
        <div id="advisor-search-results" class="advisor-search-results"></div>
    </div>
`;
}

/**
 * Handles the changes to the demo radio buttons and updates local storage.
 */
const advisorRadioButtonHandling = () => {
    // 1. Handle "Previous Demo" Change (UPDATED to use Document Delegation for stability)
    $(document).on('change', '.demo-radio', function(event, data) {
        const selectedValue = $(this).val();
        localStorage.setItem('Previous Demo Experience?', selectedValue);
        
        // Reset the "Interested" answer only if explicitly changing main toggle
        if (!data || data.resetInterestedAdvisorValue === true) {
            localStorage.setItem('Would you like to select a preferred advisor?', 'Yes'); // Default to Yes
        }

        $('#jsc-advisor-error-msg').hide();
        handleAdvisorDisplay(selectedValue);
    });

    // 2. Handle "Interested in Advisor" Change
    $(document).on('change', '.interested-advisor-radio', function() {
        const selectedValue = $(this).val();
        localStorage.setItem('Would you like to select a preferred advisor?', selectedValue);
        $('#jsc-advisor-error-msg').hide();
        
        handleAdvisorSelector(selectedValue, 'interested-advisor-radio');
    });
};

/**
 * Displays the advisor selection or interested advisor options based on the selected value.
 * @param {string} selectedValue - The value selected from the demo radio buttons.
 */
const handleAdvisorDisplay = (selectedValue) => {
    // 1. Clean up internal inputs
    $('.jsc-customer-input').children().not('.jsc-demo').remove();
    
    // 2. Clean up external Demo Code
    $('.jsc-external-demo-code').remove();

    // Case 1: Previous Demo = YES
    if (selectedValue === 'Yes') {
        const currentAdvisor = localStorage.getItem('Advisor ID');

        if (currentAdvisor && currentAdvisor !== '-' && currentAdvisor !== 'null' && currentAdvisor !== '') {
             // --- A. Advisor Exists ---
             // FIX: Inject the hidden input so validation works
             $('.jsc-customer-input').append(`<input id="search-advisor" type="hidden" value="${currentAdvisor}" name="attributes[Advisor ID]">`);

             // 1. Show the Advisor Pencil UI
             $('.jsc-advisor-select').removeClass('d-none');

             // 2. Inject Demo Code BELOW the Advisor Pencil
             const dDemo = vorwerkDemoStrings();
             const demo_code_html = `
                <div class="jsc-advisor m-b-15 relative jsc-external-demo-code" style="display: block !important;">
                    <p class="m-b-5">${dDemo.pleaseEnterDemoCode || ''} <span style="color: red;">*</span></p>
                    <input id="demo-code-input" type="text" value="" name="attributes[Demo Code]" class="advisor-text" style="width: 25ch;" placeholder="${dDemo.enterDemoCodePlaceholder || ''}">
                </div>`;
             
             $('.jsc-advisor-select').before(demo_code_html);

             // 3. Restore Demo Code Value
             const savedCode = localStorage.getItem('Demo Code');
             if (savedCode) {
                 $('#demo-code-input').val(savedCode);
             }

        } else {
             // --- B. No Advisor: Auto-Redirect ---
             $('.jsc-advisor-select').addClass('d-none');
             window.location.href = window.theme.urls.toStoreUrl('pages/choose-from-your-nearest-advisors?advisor=cart');
        }
        
        handleAdvisorSelector(selectedValue, 'demo-radio');
    } 
    // Case 2: Previous Demo = NO
    else {
        // 1. Show Question (Forced Yes)
        const dQ = vorwerkDemoStrings();
        const question_html = `
            <div class="jsc-advisor m-t-15">
                <p class="m-b-5">${dQ.preferredAdvisorQuestion || ''} <span style="color: red;">*</span></p>
                <span>
                    <input id="interested-advisor-yes" type="radio" value="Yes" aria-label="${dQ.yes || ''}" name="attributes[Would you like to select a preferred advisor?]" class="m-r-5 interested-advisor-radio" checked>
                    <label class="d-inline m-r-15" for="interested-advisor-yes">${dQ.yes || ''}</label>
                </span>
            </div>
        `;
        $('.jsc-customer-input').append(question_html);

        // 2. Logic: Check if Advisor is already selected
        const currentAdvisor = localStorage.getItem('Advisor ID');

        if (currentAdvisor && currentAdvisor !== '-' && currentAdvisor !== 'null' && currentAdvisor !== '') {
             // --- A. Advisor Exists ---
             // FIX: Inject the hidden input here too!
             $('.jsc-customer-input').append(`<input id="search-advisor" type="hidden" value="${currentAdvisor}" name="attributes[Advisor ID]">`);
             
             // Show Pencil UI
             $('.jsc-advisor-select').removeClass('d-none');
        } else {
             // --- B. No Advisor: Show Link & Redirect ---
            const dLink = vorwerkDemoStrings();
            const advisor_link_html = `
                <div class="jsc-advisor m-t-15" style="display: block !important;">
                    <p class="m-b-5">${dLink.choosePreferredAdvisor || ''} <span style="color: red;">*</span></p>
                    <p class="m-b-10" style="font-size: 0.9em;">
                        <a href="${window.theme.urls.toStoreUrl('pages/choose-from-your-nearest-advisors?advisor=cart')}" target="_blank" style="text-decoration: underline; font-weight: bold;">${dLink.findAdvisorNearYou || ''}</a>
                    </p>
                    <input id="search-advisor" type="hidden" value="" name="attributes[Advisor ID]">
                    <div id="advisor-search-results" class="advisor-search-results"></div>
                </div>
            `;
            $('.jsc-customer-input').append(advisor_link_html);
             $('.jsc-advisor-select').addClass('d-none');
             
             window.location.href = window.theme.urls.toStoreUrl('pages/choose-from-your-nearest-advisors?advisor=cart');
        }
    }
};

const handleAdvisorSelector = (selectedValue, radioClass) => {
    var removeAdvisor = false;
    var demoRadio = false;
    const advisorID = localStorage.getItem('Advisor ID');
    const advisorName = localStorage.getItem('Advisor Name');

    if (radioClass == 'demo-radio' && selectedValue == "Yes") {
        demoRadio = true;
        removeAdvisor = false;
        // REMOVED: The logic that forced .jsc-advisor-select to addClass('d-none')
        // We now WANT it to show.
    }

    if (radioClass == 'interested-advisor-radio') {
        if (selectedValue === 'No') {
            if (!$('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').addClass('d-none');
                $('#jsc-cart-advisor-name-input').val('-');
            }
            removeAdvisor = true;
        } else {
            if ($('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').removeClass('d-none');
            }
            removeAdvisor = false;
        }
    }

    // Logic to update CartJS attributes
    if (demoRadio && selectedValue == "Yes") {
        return CartJS.setAttributes({
            "Previous Demo Experience?": "Yes",
            // Keep the Advisor ID/Name in the JSON!
            "Advisor ID": `${advisorID ? advisorID : '-'}`,
            "Advisor Name": `${advisorName ? advisorName : '-'}`,
            "Would you like to select a preferred advisor?": "-"
        });
    } else {
        if (removeAdvisor) {
            return CartJS.setAttributes({
                "Advisor ID": "-",
                "Advisor Name": "-",
                "Would you like to select a preferred advisor?": "No"
            });
        } else {
            return CartJS.setAttributes({
                "Advisor ID": `${advisorID ? advisorID : '-'}`,
                "Advisor Name": `${advisorName ? advisorName : '-'}`,
                "Would you like to select a preferred advisor?": "Yes"
            });
        }
    }
}

    // $(document).on('cart.requestComplete', function(event, cart) {
    //     console.log('cart request complete');
    // })

// start: add advisor info at line item properties
addAdvisorInfoAtLineItemProperties = async () => {
    try {
        // fetch cart items
        const cart = await fetch('/cart.js').then(res => res.json());

        // Filter items that are advisor products
        // const advisorItems = cart.items.filter(item => item.properties && item.properties._is_advisor_product === "true");
        // console.log('advisorItems: ', advisorItems);

        const cartItems = cart.items;
        console.log('addAdvisorInfoAtLineItemProperties: ', cartItems);

        const currentAdvisorImg = localStorage.getItem('Advisor Profile Picture');
        const updatePromises = cartItems.map(item => {
            const updatedProps = {
                ...item.properties,
                "_Previous Demo Experience?": $('.demo-radio:checked').val() || '-',
                "_Advisor ID": localStorage.getItem('Advisor ID') || '-',
                "_Advisor Name": localStorage.getItem('Advisor Name') || '-',
                "_Advisor Profile Picture": currentAdvisorImg === '-' || currentAdvisorImg === '' ? '' : currentAdvisorImg,
                "_Would you like to select a preferred advisor?": $('.interested-advisor-radio:checked').val() || '-'
            };
            delete updatedProps["Previous Demo Experience?"];
            delete updatedProps["Advisor Name"];
            delete updatedProps["Would you like to select a preferred advisor?"];

            return CartJS.updateItemById(item.key, item.quantity, updatedProps);
        });
        console.log('updatePromises: ', updatePromises);

        // Wait for all updates to complete
        await Promise.all(updatePromises);
        return true;
    } catch (error) {
        console.error("Error updating line item properties:", error);
        return false;
    }
}
// end: add advisor info at line item properties
// start: add tax invoice info at line item properties
addTaxInvoiceInfoAtLineItemProperties = async () => {
    console.log('adding tax invoice info line item properties...');
    try {
        // fetch cart items
        const cart = await fetch('/cart.js').then(res => res.json());
        const cart_attr_obj = cart.attributes;
        const cart_items = cart.items;

        console.log('cart_attr_obj: ', cart_attr_obj, 'cart_items: ', cart_items);
        const tax_invoice_obj = {};
        if (cart_attr_obj['Tax Invoice for Legal Compliance']) {
            tax_invoice_obj['_Tax Invoice for Legal Compliance'] = cart_attr_obj['Tax Invoice for Legal Compliance'];
            if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Company') {
                // tax_invoice_obj['Company Type'] = cart_attr_obj['Company Type'];
                tax_invoice_obj['_Company Name'] = cart_attr_obj['Company Name'];
                tax_invoice_obj['_Company Registration No'] = cart_attr_obj['Company Registration No'];
            } else if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Mobile Carrier No') {
                tax_invoice_obj['_Mobile Carrier No'] = cart_attr_obj['Mobile Carrier No'];
            }
            tax_invoice_obj['_Tax Policy'] = cart_attr_obj['Tax Policy'];
        }
        console.log('tax_invoice_obj: ', tax_invoice_obj);
        if (Object.keys(tax_invoice_obj).length > 0) {
            const updatePromises = cart_items.map(item => {
                const updatedProps = {
                    ...item.properties,
                    ...tax_invoice_obj
                };
                if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Company') {
                    delete updatedProps["_Mobile Carrier No"];
                } else if(cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Mobile Carrier No') {
                    // delete updatedProps["Company Type"];
                    delete updatedProps["_Company Name"];
                    delete updatedProps["_Company Registration No"];
                } else if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Personal') {
                    delete updatedProps["_Company Name"];
                    delete updatedProps["_Company Registration No"];
                    delete updatedProps["_Mobile Carrier No"];
                }
                return CartJS.updateItemById(item.key, item.quantity, updatedProps);
            });
            await Promise.all(updatePromises);
        }
        return true;
    } catch (error) {
        console.error("Error updating line item properties:", error);
        return false;
    }
}
// end: add tax invoice info at line item properties

/**
 * Handles the checkout process, setting attributes and verifying advisor selections.
 * @param {Event} e - The event object from the checkout action.
 */
const checkout = async (e,is_advisor_product, is_advisor) => {
    if ($('#CartPageForm').attr('data-booking-checkout-blocked') === 'true') {
        return;
    }
    const _this = $(e);
    var $loader = $('.jsc-loader-overlay');
    let isValid = true;
    let addAdvisorProperties = false;
    const demoVal = $('.demo-radio:checked').val();
    const isTaxInvoiceEnabled = $('#CartPageForm').data('tax-invoice-enabled');
    const containsMainProduct = $('#CartPageForm').data('contains-main-product') || "";
    let cartAttributes = {};

    $loader.show();

    const showAdvisorCheckoutError = (message) => {
        isValid = false;
        const el = document.getElementById('jsc-advisor-error-msg');
        if (el) {
            el.textContent = message;
            el.style.display = 'block';
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            alert(message);
        }
    };

    // Terms first (same order as former validateAndCheckout; skip if checkbox not in DOM)
    const $cartTerms = $('#CartTerms');
    if ($cartTerms.length && !$cartTerms.is(':checked')) {
        isValid = false;
        showGenericAlert(vorwerkCheckoutStrings().mustAgreeTermsSales || "You must agree with the terms and conditions of sales.");
    }

    // Advisor / demo validation
    if (isValid && is_advisor_product && is_advisor) {
        $('#jsc-advisor-error-msg').hide();

        if (demoVal === undefined) {
            showAdvisorCheckoutError(vorwerkCheckoutStrings().selectDemoExperience || '');
        } else if (demoVal === 'Yes') {
            const demoCode = $('#demo-code-input').val();
            if (!demoCode || demoCode.trim() === '') {
                showAdvisorCheckoutError(vorwerkCheckoutStrings().enterDemoCode || '');
            } else {
                addAdvisorProperties = true;
                $('#jsc-advisor-error-msg').hide();
            }
        } else {
            const advisorIdValue = $('#search-advisor').val();
            if (!advisorIdValue || advisorIdValue.trim() === '' || advisorIdValue === '-') {
                showAdvisorCheckoutError(vorwerkCheckoutStrings().choosePreferredAdvisor || '');
            } else {
                addAdvisorProperties = true;
                localStorage.setItem('Advisor ID', advisorIdValue);
                $('#jsc-advisor-error-msg').hide();
            }
        }
    }

    if (isTaxInvoiceEnabled) {
        const saveResult = await saveCartAttr();
        if (saveResult === false) isValid = false;
    }

    if (isValid && is_advisor_product && is_advisor && addAdvisorProperties) {
      const addedAdvisorInfo = await addAdvisorInfoAtLineItemProperties();
      console.log('addedAdvisorInfo: ', addedAdvisorInfo);
      if (!addedAdvisorInfo) isValid = false;
    }

    if (isValid && isTaxInvoiceEnabled) {
      const addedTaxInvoiceInfo = await addTaxInvoiceInfoAtLineItemProperties();
      if (!addedTaxInvoiceInfo) isValid = false;
    }

    if (isValid) {
        // Save Demo Code if applicable
        if (demoVal === 'Yes') {
             cartAttributes["Demo Code"] = $('#demo-code-input').val();
             // Clear Advisor ID for this case
             cartAttributes["Advisor ID"] = '-';
             cartAttributes["Advisor Name"] = '-';
        } else {
             cartAttributes["Advisor ID"] = localStorage.getItem('Advisor ID') || '-';
             cartAttributes["Advisor Name"] = localStorage.getItem('Advisor Name') || '-';
        }

        cartAttributes["Previous Demo Experience?"] = demoVal || '-';
        cartAttributes["Would you like to select a preferred advisor?"] = '-'; // Deprecated

        if (containsMainProduct === true || containsMainProduct === 'true') {
            cartAttributes["Main Product"] = "Yes";
        } else {
            cartAttributes["Main Product"] = "No";
        }

        // ... (Keep existing Customer Info logic) ...
        if (window.theme.customerInfo && window.theme.customerInfo.name != 'Guest') {
            cartAttributes["shipping-firstName"] = window.theme.customerInfo.firstName;
            cartAttributes["shipping-lastName"] = window.theme.customerInfo.lastName;
            cartAttributes["Customer Name"] = window.theme.customerInfo.name;
            cartAttributes["Customer Email"] = window.theme.customerInfo.email;
            cartAttributes["Customer Address"] = window.theme.customerInfo.address;
            cartAttributes["Customer Postal Code"] = window.theme.customerInfo.postalCode;
            cartAttributes["Customer City"] = window.theme.customerInfo.city;
            cartAttributes["Customer Phone"] = window.theme.customerInfo.phone;
            cartAttributes["Home Phone"] = window.theme.customerInfo.homeNumber;
            cartAttributes["Sales Unit"] = "";
        } else {
            cartAttributes["Customer Name"] = 'Guest';
            cartAttributes["Customer Email"] = '';
            cartAttributes["Customer Address"] = '';
            cartAttributes["Customer Postal Code"] = '';
            cartAttributes["Customer City"] = '';
            cartAttributes["Customer Phone"] = '';
            cartAttributes["Home Phone"] = '';
            cartAttributes["Sales Unit"] = '';
        }

        if (!isTaxInvoiceEnabled) {
            cartAttributes["Tax Invoice for Legal Compliance"] = "";
            cartAttributes["Company Name"] = "";
            cartAttributes["Company Registration No"] = "";
            cartAttributes["Mobile Carrier No"] = "";
            cartAttributes["Tax Policy"] = "";
        }

        if (Object.keys(cartAttributes).length > 0) {
            CartJS.setAttributes(cartAttributes);
            $(document).on('cart.requestComplete', function(event, cart) {
                $loader.hide();
                $('.shopify-checkout-btn').click();
            });
        } else {
            $loader.hide();
            $('.shopify-checkout-btn').click();
        }
    } else {
        console.log('checkout not valid');
        $loader.hide();
    }
};

// start: split payment button
const splitPayment = async (is_advisor_product, is_advisor) => {
    if ($('#CartPageForm').attr('data-booking-checkout-blocked') === 'true') {
        return;
    }
    var $loader = $('.jsc-loader-overlay');
    let cartAttributes = {};
    const isTaxInvoiceEnabled = $('#CartPageForm').data('tax-invoice-enabled');
    const containsMainProduct = $('#CartPageForm').data('contains-main-product');

    // if (!isCustomerLoggedIn()) {
    //     showLoginRequiredPrompt();
    //     return false;
    // }

    $loader.show();

    let redirectButton = $('.shopify-checkout-btn')
    if ($('.spp2__button-container .spp2__payment-button').length > 0) {
        redirectButton = $('.spp2__button-container .spp2__payment-button');
    }
    console.log('redirectButton: ', redirectButton);

    if (is_advisor_product && is_advisor) {
        let isValid = true;
        const demoVal = $('.demo-radio:checked').val();

        if (demoVal === undefined) {
            $loader.hide();
            $('#jsc-advisor-error-msg').show();
            isValid = false;
        } else {
            if (demoVal === 'Yes') {
                const advisorIdValue = $('#search-advisor').val();
                localStorage.setItem('Advisor ID', advisorIdValue);
                $('#jsc-advisor-error-msg').hide();
            } else {
                const interestedAdvisor = $('.interested-advisor-radio:checked').val();
                if (interestedAdvisor === undefined) {
                    isValid = false;
                    $('#jsc-advisor-error-msg').show();
                } else {
                    if (interestedAdvisor === 'Yes') {
                        const advisorIdValue = $('#search-advisor').val();
                        localStorage.setItem('Advisor ID', advisorIdValue);
                        $('#jsc-advisor-error-msg').hide();
                    }
                }
            }
        }

        if (!$('#CartTerms').is(':checked')) {
            $loader.hide();
            showGenericAlert(vorwerkCheckoutStrings().mustAgreeTermsSales || "You must agree with the terms and conditions of sales.")
            isValid = false;
        }

        if (isTaxInvoiceEnabled) {
            const saveResult = await saveCartAttr();
            $loader.show();
            if (saveResult === false) {
                isValid = false;
            }
        }

        if (isValid && isTaxInvoiceEnabled) {
            const addedTaxInvoiceInfo = await addTaxInvoiceInfoAtLineItemProperties();
            if (!addedTaxInvoiceInfo) isValid = false;
        }

        if (isValid) {
            $loader.hide();
            const addedAdvisorInfo = await addAdvisorInfoAtLineItemProperties();
            if (addedAdvisorInfo) {
                cartAttributes["Advisor ID"] = localStorage.getItem('Advisor ID') || '-';
                cartAttributes["Advisor Name"] = localStorage.getItem('Advisor Name') || '-';
                cartAttributes["Previous Demo Experience?"] = $('.demo-radio:checked').val() || '-';
                cartAttributes["Would you like to select a preferred advisor?"] = $('.interested-advisor-radio:checked').val() || '-';

                if (containsMainProduct === true || containsMainProduct === 'true') {
                    cartAttributes["Main Product"] = "Yes";
                } else {
                    cartAttributes["Main Product"] = "No";
                }

                // customer info cart attributes
                if (window.theme.customerInfo && window.theme.customerInfo.name != 'Guest') {
                    cartAttributes["Customer Name"] = window.theme.customerInfo.name;
                    cartAttributes["Customer Email"] = window.theme.customerInfo.email;
                    cartAttributes["Customer Address"] = window.theme.customerInfo.address;
                    cartAttributes["Customer Postal Code"] = window.theme.customerInfo.postalCode;
                    cartAttributes["Customer City"] = window.theme.customerInfo.city;
                    cartAttributes["Customer Phone"] = window.theme.customerInfo.phone;
                    cartAttributes["Home Phone"] = window.theme.customerInfo.homeNumber;
                    cartAttributes["Sales Unit"] = "";
                } else {
                    cartAttributes["Customer Name"] = 'Guest';
                    cartAttributes["Customer Email"] = '';
                    cartAttributes["Customer Address"] = '';
                    cartAttributes["Customer Postal Code"] = '';
                    cartAttributes["Customer City"] = '';
                    cartAttributes["Customer Phone"] = '';
                    cartAttributes["Home Phone"] = '';
                    cartAttributes["Sales Unit"] = '';
                }

                if (!isTaxInvoiceEnabled) {
                    cartAttributes["Tax Invoice for Legal Compliance"] = "";
                    cartAttributes["Company Name"] = "";
                    cartAttributes["Company Registration No"] = "";
                    cartAttributes["Mobile Carrier No"] = "";
                    cartAttributes["Tax Policy"] = "";
                }

                if (Object.keys(cartAttributes).length > 0) {
                    CartJS.setAttributes(cartAttributes);
                    $(document).on('cart.requestComplete', function(event, cart) {
                        console.log('lplpl', event, cart);
                        $loader.hide();
                        redirectButton.click();
                    });
                } else {
                    $loader.hide();
                    redirectButton.click();
                }
            }
        } else {
            $loader.hide();
        }
    } else {
        console.log('spli-payment button not contain advisor product.');
        if (!$('#CartTerms').is(':checked')) {
            $loader.hide();
            showGenericAlert(vorwerkCheckoutStrings().mustAgreeTermsSales || "You must agree with the terms and conditions of sales.");
        } else {
            // For non-advisor products, clear advisor data from cart attributes only
            // Keep localStorage intact so advisor data can be restored later
            cartAttributes["Advisor ID"] = '-';
            cartAttributes["Advisor Name"] = '-'
            cartAttributes["Previous Demo Experience?"] = $('.demo-radio:checked').val() || '-';
            cartAttributes["Would you like to select a preferred advisor?"] = $('.interested-advisor-radio:checked').val() || '-';

            if (Object.keys(cartAttributes).length > 0) {
                CartJS.setAttributes(cartAttributes);
                $(document).on('cart.requestComplete', function(event, cart) {
                    console.log('lplpl', event, cart);
                    $loader.hide();
                    redirectButton.click();
                });
            } else {
                $loader.hide();
                redirectButton.click();
            }
        }
    }
};
// end: split payment button
/**
 * Handles the search functionality for advisors based on user input.
 * @param {Object} consultants - The list of consultants fetched from the API.
 */
const onSearchAdvisor = (consultants) => {
    $(document).on('keyup', '#search-advisor', function() {
        $('#jsc-advisor-error-msg').hide();
        const query = $(this).val().toLowerCase();
        const alphanumericRegex = /^[a-z0-9]+$/i;

        if (query !== '' && alphanumericRegex.test(query)) {
            const filteredConsultants = consultants.consultantSg.filter(consultant => {
                const consultantId = consultant["consultant'sId"].toString();
                const consultantName = consultant["consultant'sName"].toLowerCase();
                return consultantId.includes(query) || consultantName.includes(query);
            });

            $('#advisor-search-results').empty();
            if (filteredConsultants.length > 0) {
                filteredConsultants.forEach(consultant => {
                    const cl = vorwerkConsultantStrings();
                    const resultHtml = `
                        <div class="padding-10 advisor-row cursor" onclick="selectAdvisor(this, '${consultant["consultant'sId"]}')"> 
                            <span class="cursor">${cl.idLabel || ''} <b>${consultant["consultant'sId"]}</b></span><br>
                            <span class="cursor">${cl.nameLabel || ''} <b>${consultant["consultant'sName"]}</b></span>
                        </div>`;
                    $('#advisor-search-results').append(resultHtml);
                });
            } else {
                $('#advisor-search-results').append('<div class="advisor-not-found">' + (vorwerkConsultantStrings().noMatching || '') + '</div>');
            }
        } else {
            $('#advisor-search-results').empty();
        }
    });
};

/**
 * Selects an advisor from the search results and updates the input field.
 * @param {HTMLElement} e - The clicked element representing the selected advisor.
 * @param {string} id - The ID of the selected advisor.
 */
const selectAdvisor = (e, id) => {
    $('#advisor-search-results').empty();
    $('#search-advisor').val(id);
    localStorage.setItem('Advisor ID', id);
};

/**
 * Retrieves advisor-related information from local storage and updates the UI accordingly.
 */
const getAdvisorLocalStorage = () => {
    const demoValue = localStorage.getItem('Previous Demo Experience?');
    const interestedValue = localStorage.getItem('Would you like to select a preferred advisor?');
    const is_demo = demoValue ? demoValue.toLowerCase() : demoValue;
    const is_interested = interestedValue ? interestedValue.toLowerCase() : interestedValue;
    const advisor_id = localStorage.getItem('Advisor ID');
    const refId = localStorage.getItem('Referral ID');
    
    // Case 1: Demo = YES (or Referral exists)
    if (is_demo === "yes" || (is_demo !== 'yes' && refId !== null && refId !== undefined && refId !== '' && refId !== '-')) {
        $(`#demo-yes`).prop('checked', true).trigger('change', [{ resetInterestedAdvisorValue: false }]);
        
        if (advisor_id && advisor_id !== '-') {
            $('#search-advisor').val(advisor_id);
            localStorage.setItem('Advisor ID', advisor_id);
            
            // FIX: Always show the advisor name if it exists, even for "Yes"
            $('.jsc-advisor-select').removeClass('d-none');
        } 
    } 
    // Case 2: Demo = NO
    else {
        if (is_demo === 'no') {
            $(`#demo-${is_demo}`).prop('checked', true).trigger('change', [{ resetInterestedAdvisorValue: true }]);
        }

        if (is_interested === 'yes') {
            $(`#interested-advisor-${is_interested}`).prop('checked', true).trigger('change');
            if (advisor_id) {
                $('#search-advisor').val(advisor_id);
                localStorage.setItem('Advisor ID', advisor_id);
            }
        } else {
            if (!$('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').addClass('d-none');
                $('#jsc-cart-advisor-name-input').val('-');
            }
            $(`#interested-advisor-${is_interested}`).prop('checked', true);
        }
    }
};

// Scripts for Advisor feature ends here

// start: Product image - Gallery modal
initGalleryModal = (modal, _this, mainSliderArgs, productId, Slideshow) => {
    console.log('initGalleryModal');
    var tabs = modal.querySelectorAll('[data-tab]');
    const mainThumbnail = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);
    const mainFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);
    if (localStorage.getItem('productId') !== productId) {
        if (mainThumbnail) {
            const clonedThumbnail = mainThumbnail.cloneNode(true);
            localStorage.setItem('clonedThumbnail', clonedThumbnail.outerHTML);
        }
        if (mainFlickity) {
            const clonedFlickity = mainFlickity.cloneNode(true);
            localStorage.setItem('clonedFlickity', clonedFlickity.outerHTML);
        }
        localStorage.setItem('productId', productId);
    }

    // init gallery modal tab
    if (tabs) {
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabName = event.currentTarget.getAttribute('data-tab');

                /* start: active tab color */
                tabs.forEach(sibling => {
                    sibling.classList.remove('is-active');
                });

                tab.classList.add('is-active');
                /* end: active tab color */

                /* start: destroy flickity */
                if (_this.flickity && typeof _this.flickity.destroy === 'function') {
                    _this.flickity.destroy();
                    console.log('flickity destroy');
                }
                /* end: destroy flickity */

                /* start: clone thumbnail flickity */
                var thumbnailFlickity = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);

                if (thumbnailFlickity) {
                    clonedFlickity('clonedThumbnail', tabName, 'product__thumb-item', thumbnailFlickity, _this, mainSliderArgs);
                }
                /* end: clone thumbnail media flickity */

                /* start: clone main product media flickity */
                var galleryModalFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);

                if (galleryModalFlickity) {
                    clonedFlickity('clonedFlickity', tabName, 'product-main-slide', galleryModalFlickity, _this, mainSliderArgs, Slideshow);
                }
                /* end: clone main product media flickity */
            })
        })
    }
}
// end: Product image - Gallery modal


clonedFlickity = (name, tabName, slideClass, flickityElement, _this, mainSliderArgs, Slideshow=null) => {
    console.log('clonedFlickity: ', name);
    const storedElementHTML = localStorage.getItem(name);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = storedElementHTML;
    const retrievedElement = tempDiv.firstChild;
    retrievedElement.classList.add(name);

    const slideElement = retrievedElement.querySelectorAll(`.${slideClass}`);

    let currentThumbnailIndex = -1;
    slideElement.forEach(function(slide, index) {
        if (tabName == 'image' && slide.dataset.mediaType !== 'image') {
            slide.remove();
        } else if (tabName == 'video' && slide.dataset.mediaType !== 'video'){
            slide.remove();
        } else if (name == 'clonedThumbnail') {
            currentThumbnailIndex += 1
            slide.setAttribute('data-index', currentThumbnailIndex);
        }
    })

    flickityElement.parentNode.insertBefore(retrievedElement, flickityElement);
    flickityElement.remove();
    retrievedElement.classList.remove(name);

    if (mainSliderArgs) {
        if (name == 'clonedThumbnail') {
            mainSliderArgs.childNav = retrievedElement
        } else if (name == 'clonedFlickity' && Slideshow != null) {
            _this.flickity = new Slideshow(retrievedElement, mainSliderArgs);
            setTimeout(() => {
                _this.flickity.resize()
            }, 100)
            _this.initImageZoom();
        }
    }
}

setSliderEqualHeight = (blockId) => {
    console.log('setSliderEqualHeight - blockId: ', blockId);

    if (!blockId) {
        console.warn('setSliderEqualHeight: blockId is required');
        return;
    }

    const sectionClass = 'section--' + blockId;
    const $slider = $(`.${sectionClass}.text-columns--slider`);
    if (!$slider.length) return;

    const $slides = $slider.find('.flickity-cell');
    const $flickityViewport = $slider.find('.flickity-viewport');
    if (!$slides.length) return;

    let maxHeight = 0;

    // Reset heights
    $slides.css('height', 'auto');

    // Calculate tallest height (only if visible)
    let haveVisibleSlide = false;
    $slides.each(function() {
        const $slide = $(this);
        if ($slide.is(':visible')) {
            haveVisibleSlide = true;
            const height = $slide.outerHeight();
            if (height > maxHeight) maxHeight = height;
        }
    });
    console.log("haveVisibleSlide: ", haveVisibleSlide)

    // If slider still hidden (height=0), retry after short delay
    if (haveVisibleSlide && maxHeight === 0) {
        setTimeout(() => setSliderEqualHeight(blockId), 50);
        return;
    }

    // Apply equal height (+5px buffer)
    $slides.css('height', `${maxHeight + 5}px`);
    $flickityViewport.css('height', `${maxHeight + 5}px`);
}

initTextColumnsFlickity = () => {
    console.log('initTextColumnsFlickity');

    $('.text-columns__flickity-slider').each(function() {
        const $slider = $(this);
        const setEqualHeight = $slider.data('set-equal-height') === true || $slider.data('set-equal-height') === 'true';
        const blockId = $slider.data('block-id') || "";
        const isAdaptiveHeight = !(setEqualHeight && blockId != "")

        console.log('isAdaptiveHeight: ', isAdaptiveHeight);
        console.log('setEqualHeight: ', setEqualHeight);
        console.log('blockId: ', blockId);

        // Initialize Flickity
        const flkty = $slider.flickity({
            cellAlign: 'left',
            freeScroll: true,
            wrapAround: true,
            adaptiveHeight: isAdaptiveHeight,
            prevNextButtons: true,
            pageDots: true,
            resize: true
        });

        setTimeout(() => {
            flkty.resize();
            if (setEqualHeight && blockId) {
                setSliderEqualHeight(blockId);
            }
        }, 100);

        // Recalculate equal heights on window resize
        if (setEqualHeight && blockId) {
            $(window).on('resize orientationchange', () => {
                setSliderEqualHeight(blockId);
            });
        }
    });
}

// Start of Storepoint customisation
bindFunction = () =>{
    $('.stpt-marker').attr('onclick', 'triggerMapPopup()');
    $('.storepoint-location').attr('onclick', 'triggerMapPopup()');
    if ($('#storepoint-container').length) {
        var $loader = $('.jsc-loader-overlay');
        $loader.hide();
    }
}

eventListnerTriggerPopup = () =>{
    $('body').on('click', '.storepoint-location, .stpt-marker', function() {
        triggerMapPopup();
    });
    $('.mapboxgl-ctrl-geocoder--input').on('keydown', function(event) {
        if (event.key === 'Enter') {
            triggerMapPopup();
        }
    });
}
triggerMapPopup = () => {
    setTimeout(() => {
        // Safety check
        if ($('.street-address').length && $('.storepoint-popup-description').length) {
            $('.street-address').insertBefore($('.storepoint-popup-description'));
        }
    
        var languages = [];
        var _id = '';
        var _location = null; 

        $('.tag-text').each(function(){
            var _this = $(this);
            var text = _this.text();

            _location = _this;
            
            if (text.includes('id_') || text.includes('Id_')) {
                _this.parents('span.tag').hide();
                _id = text.split('_')[1];
            } else if (text.includes('food_') || text.includes('Food_')) {
                _this.text(text.split('_')[1]);
            } else if (text.includes('language_') || text.includes('Language_')) {
                var language = text.split('_')[1];
                languages.push(language);
                _this.parents('span.tag').hide();
            }
        });

        // CRITICAL FIX: We added this check. 
        // If _location is still null, we STOP here so the script doesn't crash.
        if (_location) {
            var uniqueLanguanges = Array.from(new Set(languages));
            var html = `<div class="jsc-language text-left m-b-10 hide">`;
            uniqueLanguanges.forEach(element => {
                html += `<span class="uppercase m-r-5">${element}</span>`
            });
            html += `</div>`;
            
            if (!_location.parents('.storepoint-location-popup').find('.jsc-language').length) {
                _location.parents('.storepoint-location-popup').prepend(html);
            }
            if ($(`.tag-id_${_id}`).length && !$(`.tag-id_${_id}`).parents('.storepoint-location').find('.jsc-language').length) {
                $(`.tag-id_${_id}`).parents('.storepoint-location').prepend(html);
            }
            
            var current_name = _location.parents('.storepoint-location-popup').find('b').text();
            var current_id = localStorage.getItem('Advisor ID');
            
            if(current_id == _id ) {
                $('.jsc-select-btn').attr('disabled','disabled').text('Selected');
            }
        }
    }, 60);
}

selectMapAdvisor = (e, id, name, profileImg) =>{
    // Use updateAdvisorData function to handle all advisor data updates
    const profilePicture = (!profileImg || profileImg === '-') ? '' : profileImg;
    updateAdvisorData(id, name, profilePicture, false);

    // Update button state
    $(e).prop('disabled', true).text(vorwerkStorepointWidgetStrings().selectedLocationButtonText || 'Selected');
    console.log('ppokee', getUrlParameter('advisor'));

    if (getUrlParameter('advisor') == 'cart') {
        $(document).on('cart.requestComplete', function(event, cart) {
            location.href = window.theme.urls.toStoreUrl('cart');
        });
    } else {
        $(document).on('cart.requestComplete', function(event, cart) {
            if (id && id !== '-') {
                location.href = window.theme.urls.toStoreUrl('pages/storepoint-bnl/id_' + id);
            } else {
                location.href = window.theme.urls.toStoreUrl('');
            }
        });
    }
    
    var storepointID = window.location.href.split('selected=')[1];
    //console.log('storepointID 1',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);
}

getUrlParameter = (name) =>{
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// End of Storepoint customisation


// start: pdpa function
// track bank account name checkbox
$('#bank_account_name_checkbox').on('change', function() {
    if ($(this).prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
            $('#bank_account_name_checkbox_error').css('display', 'none');
        } else {
            $('#bank_account_name_checkbox_error').css('display', 'block');
        }
    } else {
        $('#bank_account_name').removeClass('jsc-disable-field');
        $('#bank_account_name_checkbox_error').css('display', 'none');
    }
});
// track mobile number
$('#jsc-telephone').on('focus input', function() {
    $phoneInput = $('#jsc-telephone');
    let value = $phoneInput.val();

      if (value.startsWith('+65')) {
        $phoneInput.val('+65' + value.slice(3).replace(/\D/g, ''));
      } else {
        $phoneInput.val('+65');
      }
});
// track full name
$('#full_name').on('input', function() {
    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name_val = $('#full_name').val();
        $('#bank_account_name').val(full_name_val);
    }
});
// track postal code
$('#postal_code').on('input', function() {
    $postal_code = $('#postal_code');

    if ($postal_code.val().length > 6) {
        $postal_code.val($postal_code.val().slice(0, 6));
    }
});
/* intl-tel-input library: https://intl-tel-input.com/examples/validation.html */
initIntlTelInput = () => {
    const input = document.querySelector("#register_mobile");
    // initialise plugin
    intlTelInstance['iti'] = window.intlTelInput(input, {
        initialCountry: "my",
        loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js",
        separateDialCode: true, // Display country code separately
        nationalMode: false,    // Use full international number format
    });
    console.log('intlTelInstance: ', intlTelInstance);
}
fetchNationality = () => {
    fetch('https://cdn.shopify.com/s/files/1/0717/2305/7409/files/jsc-nationality-list.json')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(nationalities => {
            // console.log(nationalities);
            if (nationalities.length > 0) {
                $.each(nationalities, function(index, item) {
                    const listItem = $('<option></option>').text(item.Nationality).val(item.Nationality);
                    const nationalityData = $('#nationality').attr('data-default') ? $('#nationality').attr('data-default').toLowerCase() : $('#nationality').attr('data-default');
                    if (item.Nationality && item.Nationality.toLowerCase() === nationalityData) {
                        listItem.prop('selected', true);
                    }
                    $('#nationality').append(listItem);
                });
            }
        })
        .catch(error => {
            console.error('Fetch nationality error:', error);
        });
}
fetchSGBankList = () => {
    fetch('https://cdn.shopify.com/s/files/1/0717/2305/7409/files/jsc-sg-bank-list.json?v=1733284205')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(availableBank => {
            // console.log(availableBank);
            if (availableBank.length > 0) {
                $.each(availableBank, function(index, bank) {
                    const listItem = $('<option></option>').text(bank['Reporting Institutions']).val(bank['Reporting Institutions']);
                    const bankData = $('#bank_name').attr('data-default') ? $('#bank_name').attr('data-default').toLowerCase() : $('#bank_name').attr('data-default');
                    if (bank['Reporting Institutions'] && bank['Reporting Institutions'].toLowerCase() === bankData) {
                        listItem.prop('selected', true);
                    }
                    $('#bank_name').append(listItem);
                });
            }
        })
        .catch(error => {
            console.error('Fetch nationality error:', error);
        });
}
enableAccountUpdateWhenFoundChanges = () =>{
    fetchNationality();
    fetchSGBankList();
    // Get the input elements
    // accepts marketing inputs: #accepts_marketing_email, #accepts_marketing_sms, #accepts_marketing_post, #accepts_marketing_telephone
    var accountPagePdpaInputs = $("#alias, #email, #full_name, #nationality, #register_mobile, #register_home, #postal_code, #address_1, #address_2, #bank_name, #bank_account_name, #bank_account_name_checkbox, #bank_account_number, #accepts_policy");

    // Get the submit button
    var updatePdpaButton = $("#update-profile");

    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
        } else {
            $('#bank_account_name_checkbox').prop('checked', false);
        }
    }

    // Store the initial values
    var initialValues = {};
    accountPagePdpaInputs.each(function () {
      if ($(this).is(":checkbox")) {
        initialValues[this.id] = $(this).prop("checked");
      } else {
        initialValues[this.id] = $(this).val();
      }
    });

    // Add event listener to all input fields
    accountPagePdpaInputs.on("input change", function () {
      var allValuesMatch = accountPagePdpaInputs.toArray().every(function (input) {
        if ($(input).is(":checkbox")) {
          // For checkboxes, check the "checked" property
          return $(input).prop("checked") === initialValues[input.id];
        } else {
          // For other input types, check the "value" property
          return $(input).val() === initialValues[input.id];
        }
      });

      // Enable or disable the submit button based on whether any values have changed
      updatePdpaButton.prop("disabled", allValuesMatch);
    });
}
customerInfoValidation = ($email, $full_name, $nationality, $register_mobile, $register_home) => {
    var $passValidation = true;

    // 1. Email Check
    if ($email == '') {
        $('#email_error').show();
        $passValidation = false;
    } else {
        $('#email_error').hide();
        if ($email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
            $('#email_format_error').hide();
        } else {
            $('#email_format_error').show();
            $passValidation = false;
        }
    }

    // 2. Name Check
    if ($full_name == '') {
        $('#full_name_error').show();
        $passValidation = false;
    } else {
        $('#full_name_error').hide();
    }

    // 3. Nationality Check
    if ($nationality == '') {
        $('#nationality_error').show();
        $passValidation = false;
    } else {
        $('#nationality_error').hide();
    }

    // 4. CLEAN MOBILE CHECK (Removed the console.log that was crashing)
    if ($register_mobile.trim() == '') {
        $('#register_mobile_error').show();
        $passValidation = false;
    } else {
        $('#register_mobile_error').hide();
        $('#register_mobile_format_error').hide();
    }

    return $passValidation;
}
addressValidation = ($address_1, $postal_code) => {
    var $passValidation = true;
    if ($address_1 == '') {
        $('#address_1_error').show();
        $passValidation = false;
    } else {
        $('#address_1_error').hide();
    }

    // console.log('pos: ', $postal_code);
    if ($postal_code == ''){
        $('#postal_code_error').show();
        $passValidation = false;
    } else {
        $('#postal_code_error').hide();
        // https://en.wikipedia.org/wiki/Postal_codes_in_Singapore (consisted of six digits since 1995)
        // https://gist.githubusercontent.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b/raw/21662445653ac861f8ab81caa8cfaee3185aed15/postal-codes.json (postal code regex)
        if ($postal_code.match(/^\d{6}$/)) {
            $('#postal_code_format_error').hide();
        } else {
            $('#postal_code_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
bankValidation = ($bank_name, $bank_account_name, $bank_account_number) => {
    var $passValidation = true;
    if ($bank_name == '') {
        $('#bank_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_name_error').hide();
    }

    if ($bank_account_name == '') {
        $('#bank_account_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_name_error').hide();
    }

    if ($bank_account_number == '') {
        $('#bank_account_number_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_number_error').hide();
        if ($bank_account_number.length >= 7 && $bank_account_number.length <= 15) {
            $('#bank_account_number_format_error').hide();
        } else {
            $('#bank_account_number_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
acceptsMarketingValidation = ($accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone) => {
    var $passValidation = true;
    var show_accepts_marketing_error = true;
    if ($accepts_marketing_email || $accepts_marketing_sms || $accepts_marketing_post || $accepts_marketing_telephone) {
        show_accepts_marketing_error = false
    }
    if (show_accepts_marketing_error) {
        $('#accepts_marketing_error').show();
        $passValidation = false;
    } else {
        $('#accepts_marketing_error').hide();
    }

    if ($accepts_marketing_sms) {
        if (intlTelInstance['iti'].isValidNumberPrecise()) {
            $('#accepts_marketing_sms_error').hide();
        } else {
            $('#accepts_marketing_sms_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
advisorCustomerAPI = (id, em, advid, recid, recn, fn, nt, mo, ho, add, add2, pc, ctry, nob, accn, accnum, lang, spec, alias, sendEmail, mce, mcs, mct, lat, lng) =>{
    let $data = {
        id: id,
        advisor_id: advid,
        last_name: fn,
        address: add,
        address2: add2,
        country: ctry,
        postal_code: pc,
        email: em,
        mobile: mo,
        home: ho,
        nationality: nt,
        bank_name: nob,
        bank_account_name: accn,
        bank_account_number: accnum,
        recruiter_id: recid,
        recruiter_name: recn,
        language: lang,
        specialities: spec,
        alias: alias,
        send_email: sendEmail,
        email_marketing_consent: mce,
        sms_marketing_consent: mcs,
        tel_marketing_consent: mct,
        latitude: lat,   // Verified: This is correct
        longitude: lng   // Verified: This is correct
    };
    
    // Production Settings webhook user/advisor/update (9af9a9a0). No production task
    // subscribes — staging task advisor-update-profile-frontend-webhook is disabled (SKIP).
    // POST is accepted but nothing runs (same as staging). Stops cross-store leakage only;
    // does not restore profile-update automation unless that task is enabled/created later.
    $.ajax({
        url: "https://webhooks.mechanic.dev/9af9a9a0-b65a-4165-8eb7-c4d81ed6b752",
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
customerAPI = (id, add, add2, pc, ctry) => {
    let $data = {
        id: id,
        address: add,
        address2: add2,
        country: ctry,
        postal_code: pc
    };

    // Legacy Mechanic URL — NOT in Settings → Mechanic webhooks (no admin row).
    // Topic user/custom/update; task subscription is shop-specific, not this Settings table.
    $.ajax({
        url: "https://webhooks.mechanic.dev/7f87e529-5829-42e3-b01c-0534bde2ca4b", // user/custom/update
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
updatePdpaAdvisor = (evt,is_tm4u) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $full_name = $('#full_name').val();
    var $nric = $('#nric').val();
    var $nationality = $('#nationality').val();
    var $register_mobile = $('#register_mobile').val();
    var $register_home = $('#register_home').val();
    var $alias = $('#alias').val();

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();
    
    // --- 1. GRAB GPS DATA (Crucial Step!) ---
    var $advisor_latitude = $('#advisor_latitude').val();
    var $advisor_longitude = $('#advisor_longitude').val();

    var $bank_name = $('#bank_name').val();
    var $bank_account_name = $('#bank_account_name').val();
    var $bank_account_number = $('#bank_account_number').val();

    var $advisor_language = $('#language_label').text().replace('Language', '');
    var $advisor_specialities = $('#specialities_label').text().replace('Specialities', '');

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $email = $('#email').val();
    var $advisor_id = $('#advisor_id').val();
    var $recruiter_id = $('#recruiter_id').val();
    var $recruiter_name = $('#recruiter_name').val();

    // Use the safe validation we added earlier
    var $isvalidatedCustomerInfo = customerInfoValidation($email, $full_name, $nationality, $register_mobile, $register_home);
    var $isvalidatedAddress = addressValidation($address_1, $postal_code);
    var $isvalidatedBank = bankValidation($bank_name, $bank_account_name, $bank_account_number);

    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    var $isvalidatedAdvisorLanguage = true;
    if (!is_tm4u) {
        if ($advisor_language == '') {
            $isvalidatedAdvisorLanguage = false;
            $('#language_blank_error').show();
        } else {
            $('#language_blank_error').hide();
            $('#language_error').hide();
        }
    }

    var $isvalidatedAdvisorSpecialities = true;
    if (!is_tm4u) {
        if ($advisor_specialities == '') {
            $isvalidatedAdvisorSpecialities = false;
            $('#specialities_blank_error').show();
        } else {
            $('#specialities_blank_error').hide();
            $('#specialities_error').hide();
        }
    }

    var $send_update_email = true;
    var $email_marketing_channel = '';
    var $sms_marketing_channel = '';
    var $tel_marketing_channel = '';
    var $isvalidatedAcceptsMarketing = true;

    if (is_tm4u) {
        $send_update_email = false;
        var $email_marketing_channel = $('#marketing_channel_email').prop("checked").toString().toLowerCase();
        var $sms_marketing_channel = $('#marketing_channel_sms').prop("checked").toString().toLowerCase();
        var $tel_marketing_channel = $('#marketing_channel_telephone').prop("checked").toString().toLowerCase();
        if ($sms_marketing_channel == 'false') {
            $isvalidatedAcceptsMarketing = false;
        }
    }
    if (!$isvalidatedAcceptsMarketing) {
        $('#accepts_marketing_error').show();
    } else {
        $('#accepts_marketing_error').hide();
    }

    if ($isvalidatedCustomerInfo && $isvalidatedAddress && $isvalidatedBank && $isvalidatedAcceptsCondition && $isvalidatedAdvisorLanguage && $isvalidatedAdvisorSpecialities && $isvalidatedAcceptsMarketing) {
        
        // --- SAFE PHONE FORMATTING START (Crash Proof) ---
        if (typeof intlTelInstance !== 'undefined' && intlTelInstance['iti']) {
            const intlTelCountryData = intlTelInstance['iti'].getSelectedCountryData();
            if (intlTelCountryData && intlTelCountryData.dialCode) {
                const dialCode = `+${intlTelCountryData.dialCode}`;
                if ($register_mobile && !$register_mobile.includes(dialCode)) {
                    $register_mobile = `+${intlTelCountryData.dialCode}${$register_mobile}`;
                }
            }
        }
        // --- SAFE PHONE FORMATTING END ---

        // --- 2. SEND DATA TO MECHANIC (Now includes GPS!) ---
        advisorCustomerAPI($shopifyId,
            $email, $advisor_id, $recruiter_id, $recruiter_name,
            $full_name, $nationality, $register_mobile, $register_home,
            $address_1, $address_2, $postal_code, $address_country_code,
            $bank_name, $bank_account_name, $bank_account_number,
            $advisor_language, $advisor_specialities, $alias, $send_update_email,
            $email_marketing_channel, $sms_marketing_channel, $tel_marketing_channel,
            $advisor_latitude, $advisor_longitude  // <--- HERE IS THE KEY CHANGE
        )
        
        setTimeout(() => {
            $loader.hide();
            if (is_tm4u) {
                var product_link = $(evt).attr('data-product-link');
                if (product_link) {
                    if (/^https?:\/\//i.test(product_link) || product_link.indexOf('//') === 0) {
                        window.location.href = product_link;
                    } else {
                        window.location.href = window.theme.urls.toStoreUrl(product_link.replace(/^\/+/, ''));
                    }
                }
            } else {
                location.reload();
            }
        }, 15000);
    } else {
        $loader.hide();
    }
}
updatePdpa = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $isvalidatedAddress = addressValidation($address_1, $postal_code);

    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    console.log('isvalidatedAddress: ', $isvalidatedAddress);

    if ($isvalidatedAddress && $isvalidatedAcceptsCondition) {
        customerAPI($shopifyId,
            $address_1, $address_2, $postal_code, $address_country_code
        )
        setTimeout(() => {
            $loader.hide();
            location.reload();
        }, 4500);
    } else {
        $loader.hide();
    }
}
openOptions = (e) => {
    const _this = $(e);
    const optionsEl = _this.siblings('.custom-options');
    _this.toggleClass('active');
    optionsEl.toggleClass('d-none');
}
// track specialities
updateSpecialities = (e) => {
    const _this = $(e);
    const specialitiesLabel = $('#specialities_label').text();
    var specialitiesArr = specialitiesLabel.split(',');
    var addSpecialities = false;

    if (_this.prop("checked")){
        addSpecialities = true;
    }

    if (addSpecialities && specialitiesLabel != 'Specialities') {
        specialitiesArr.push(_this.val());
    } else if (addSpecialities && specialitiesLabel == 'Specialities') {
        specialitiesArr.push(_this.val());
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== 'Specialities';
        });
    }

    if (addSpecialities === false) {
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (specialitiesArr.length <= 0) {
        $('#specialities_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (specialitiesArr.length > 3) {
        $('#specialities_blank_error').hide();
        $('#specialities_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#specialities_blank_error').hide();
        $('#specialities_error').hide();
        $('#specialities_label').text(specialitiesArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// track language
updateLanguage = (e) => {
    const _this = $(e);
    const langLable = $('#language_label').text();
    var langArr = langLable.split(',');
    var addLang = false;

    if (_this.prop("checked")){
        addLang = true;
    }

    if (addLang && langLable != 'Language') {
        langArr.push(_this.val());
    } else if (addLang && langLable == 'Language') {
        langArr.push(_this.val());
        langArr = langArr.filter(function(item) {
            return item !== 'Language';
        });
    }

    if (addLang === false) {
        langArr = langArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (langArr.length <= 0) {
        $('#language_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (langArr.length > 5) {
        $('#language_blank_error').hide();
        $('#language_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#language_blank_error').hide();
        $('#language_error').hide();
        $('#language_label').text(langArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// end: pdpa function
// start: Recover Password Form
showRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "true") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'false');
        $('#RecoverPasswordForm').removeClass('hide');
        $('#CustomerLoginForm').addClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'true');
    }
}
hideRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "false") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'true');
        $('#RecoverPasswordForm').addClass('hide');
        $('#CustomerLoginForm').removeClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'false');
    }
}
// end: Recover Password Form
// start: section anchor
getAnchorLink = (evt) => {
    var anchorLink = $(evt).attr('href');
    scrollToSection(anchorLink);
}

onloadGetAnchorLink = () => {
    var anchorLink = window.location.hash;
    console.log('onloadGetAnchorLink: ', onloadGetAnchorLink);
    if(anchorLink != "") {
      scrollToSection(anchorLink);
    }
}

scrollToSection = (link) => {
    var target = $('[data-anchor="' + link + '"]:first');
    if(target.length > 0) {
      window.location.hash = link;
      var top = target.offset().top - 150;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
}
// end: section anchor
// start: referral link
copyReferralLink = () => {
    // Get the text field
    var referralLink = $('#referral_link')[0];

    // Select the text field
    referralLink.select();
    referralLink.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(referralLink.value).then(function() {
        $('#copied-label').fadeIn().delay(1000).fadeOut();
    }).catch(function(error) {
        console.error("Failed to copy text: " + error);
    });;
};
// end: referral link
checkReferral = async () => {
    const $loader = $('.jsc-loader-overlay');
    console.log('Checking referral...');
    $loader.show();

    try {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('ref')) {
            console.log('No referral parameter found');
            return;
        }

        // Parse referral data
        const ref = urlParams.get('ref');
        const [refId, refNameEncoded] = ref.split('@');
        const refName = refNameEncoded?.replace(/_/g, ' ') || '';
        console.log('Referral ID:', refId, 'Name:', refName);

        // Get current advisor data
        const currentAdvisorId = localStorage.getItem('Advisor ID');
        const storedRefId = localStorage.getItem('Referral ID');

        // Check if this is a new referral or different from current advisor
        // const isNewReferral = refId !== storedRefId;
        // const isDifferentAdvisor = refId !== currentAdvisorId;

        // if (!isNewReferral && !isDifferentAdvisor) {
        //     console.log('Referral already set as advisor');
        //     return;
        // }

        // Validate if referral is a valid advisor and get profile picture
        const advisorValidation = await validateAdvisor(refId);

        if (advisorValidation) {
            // advisorValidation is [true, profilePicture]
            const [isValid, profilePicture] = advisorValidation;
            
            if (isValid) {
                // Update localStorage with new advisor data including profile picture
                updateAdvisorData(refId, refName, profilePicture, true);
                console.log('Advisor updated successfully with profile picture:', profilePicture);
            } else {
                // Validation returned false, clear advisor data
                clearAdvisorData();
                console.log('Referral validation failed, advisor data cleared');
            }
        } else {
            // Validation returned false, clear advisor data
            clearAdvisorData();
            console.log('Referral is not a valid advisor, advisor data cleared');
        }
    } catch (error) {
        console.error('Error in checkReferral:', error);
    } finally {
        $loader.hide();
    }
}

// Helper function to validate if an ID belongs to a valid advisor and fetch profile picture
const validateAdvisor = async (advisorId) => {
    try {
        const response = await fetch(`/pages/storepoint-bnl/id_${advisorId}?sections=advisor-validate`);
        console.log('validate advisor: ', response.status);

        if (response.status === 404) return false;

        const sections = await response.json();
        const html = sections["advisor-validate"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        // Get the JSON script content
        const script = doc.querySelector('script[type="application/json"]');
        if (!script) return false;

        const data = JSON.parse(script.textContent);
        // console.log('validateAdvisor - data: ', data);

        if (!data.valid) return false;

        return [true, data.profile_picture || ''];
    } catch (error) {
        // console.error('Error validating advisor:', error);
        return false;
    }
}

const validateExistingAdvisor = async () => {
    const advisorId = localStorage.getItem('Advisor ID');
    if (!advisorId) return;
    const advisorValidation = await validateAdvisor(advisorId);

    if (advisorValidation) {
        const [isValid] = advisorValidation;
        // console.log('isValid: ', isValid);
        if (!isValid) {
            clearAdvisorData();
            return;
        }
    } else {
        clearAdvisorData();
        return;
    }
}

// Helper function to update advisor data in localStorage, cart attributes and UI
const updateAdvisorData = (advisorId, advisorName, advisorProfilePicture = '', isReferral = false) => {
    // Update localStorage
    localStorage.setItem('Advisor ID', advisorId);
    localStorage.setItem('Advisor Name', advisorName);
    localStorage.setItem('Advisor Profile Picture', advisorProfilePicture);
    var storepointID = window.location.href.split('selected=')[1];
    // console.log('storepointID 2',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);

    // Only update referral localStorage if isReferral is true
    if (isReferral) {
        localStorage.setItem('Referral ID', advisorId);
        localStorage.setItem('Referral Name', advisorName);
    }

    // Update cart attributes
    CartJS.setAttributes({
        'Advisor ID': advisorId,
        'Advisor Name': advisorName,
        'Advisor Profile Picture': advisorProfilePicture
    });

    // Update UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text(advisorName);
    }

    // Dispatch advisor:selected event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:selected', {
        detail: {
            id: advisorId,
            name: advisorName,
            profileImg: advisorProfilePicture
        }
    }));
}
// Helper function to clear advisor data from localStorage, cart attributes and UI
const clearAdvisorData = () => {
    // Clear localStorage
    localStorage.removeItem('Advisor ID');
    localStorage.removeItem('Advisor Name');
    localStorage.removeItem('Advisor Profile Picture');
    localStorage.removeItem('Referral ID');
    localStorage.removeItem('Referral Name');
    localStorage.removeItem('Advisor Storepoint ID');

    // Clear cart attributes
    CartJS.setAttributes({
        'Advisor ID': '',
        'Advisor Name': '',
        'Advisor Profile Picture': '-'
    });

    // Clear UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text('');
    }

    // Clear advisor name input if exists
    const $advisorNameInput = $('#jsc-cart-advisor-name-input');
    if ($advisorNameInput.length) {
        $advisorNameInput.val('');
    }

    // Clear search advisor input if exists
    const $searchAdvisorInput = $('#search-advisor');
    if ($searchAdvisorInput.length) {
        $searchAdvisorInput.val('');
    }

    // Dispatch advisor:cleared event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:cleared'));
}
hideCustomerCartInput = () => {
    const refId = localStorage.getItem('Referral ID');
    const refName = localStorage.getItem('Referral Name');
    if (refId && refName) {
        if (!$('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').addClass('d-none');
        }
        localStorage.setItem('Previous Demo Experience?', '-');
        localStorage.setItem('Would you like to select a preferred advisor?', '-');
    } else {
        if ($('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').removeClass('d-none');
        }
    }
}
// start: register form
submitRegisterForm = (e) =>{
    console.log('submitRegisterForm...')
    const password = $('#CreatePassword').val();
    const phone = $('#jsc-telephone').val();
    const address1 = $('#jsc-address1').val();
    const address2 = $('#jsc-address2').val();
    const postalCode = $('#jsc-postal-code').val();
    const $loader = $('.jsc-loader-overlay');
    var passRegister = true;

    $loader.show();
    console.log('jsc-telephone: ', phone);
    // Check if password length is less than 12
    if (password.length < 12) {
        $('#password-error').show(); // Show error message
        passRegister = false;
    } else {
        $('#password-error').hide(); // Hide error message
    }

    // Check if the phone follow Sinagpore mobile fomat
    if (phone != '' || phone != '+65') {
        $('#phone-blank-error').hide();
        if (phone.match(/^\+65(6|8|9)\d{7}$/)) {
            $('#phone-format-error').hide(); // Show error message
        } else {
            $('#phone-format-error').show(); // Hide error message
            passRegister = false;
        }
    } else {
        $('#phone-blank-error').show();
        passRegister = false;
    }

    // Check address 1
    if (address1 == '') {
        $('#address1-blank-error').show();
        passRegister = false;
    } else {
        $('#address1-blank-error').hide();
    }

    // Check postal code format
    if (postalCode == ''){
        $('#zip-blank-error').show();
        passRegister = false;
    } else {
        $('#zip-blank-error').hide();
        if (postalCode.match(/^\d{6}$/)) {
            $('#zip-format-error').hide();
        } else {
            $('#zip-format-error').show();
            passRegister = false;
        }
    }

    console.log('passRegister: ', passRegister);
    if(passRegister) {
        $('#register-form-error').hide();
        const formated_address1 = address1.replace(/,/g, '%&%');
        const formated_address2 = address2.replace(/,/g, '%&%');
        const customer_tag = `__tel:${phone},__address1:${formated_address1},__address2:${formated_address2},__zip:${postalCode}`;
        $('#jsc-customer-tag').val(customer_tag);
        setTimeout(() => {
            $('#register-submit').click();
            $loader.hide();
        }, 2000);
    } else {
        $('#register-form-error').show();
        // Find first visible error from known error IDs
        if ($('#register-form-error')) {
            $('html, body').animate({
                scrollTop: $('#register-form-error').offset().top - 100
            }, 500);
        }
        $loader.hide();
    }
}

//start:Pagination
tablePaginate = () =>{
    // if($('#jsc-advisor-report').length > 0) {
    //     $('#jsc-advisor-report').createTablePagination({
    //         rowPerPage: 20,
    //     });
    // }

    // $('#jsc-advisor-report').DataTable({
    //     pageLength: 20,
    //     lengthChange: false
    // });
}
//end:Pagination
limitInput = (input, maxLength) => {
    if (input.value.length > maxLength) {
        input.value = input.value.slice(0, maxLength);
    }
}
// start: faq collapsible
showMoreCollapsible = (e) => {
    const _this = $(e);
    const _container = $(e).parent();
    const _showLessBtn = _this.siblings('.collapsible-show-less');
    const _siblings = _this.siblings('.jsc-faq-collapsible.d-none');
    console.log('_siblings: ', _siblings)
    if (_siblings.length > 0){
        $.each(_siblings, function(index, element) {
            $(element).removeClass('d-none');
        });
        _this.css('display', 'none');
        _showLessBtn.css('display', 'block');
        _showLessBtn.insertAfter(_container.find('.jsc-faq-collapsible').last());
    }
}
showLessCollapsible = (e) => {
    const _this = $(e);
    const _showMoreBtn = _this.siblings('.collapsible-show-more');
    const _siblings = _this.siblings('.jsc-faq-collapsible');
    $.each(_siblings, function(index, element) {
        $(element).addClass('d-none');
    });
    _this.css('display', 'none');
    _showMoreBtn.css('display', 'block');
}
// end: faq collapsible
initAdvisorSelector = () => {
    const advisorID = localStorage.getItem('Advisor ID');
    const advisorName = localStorage.getItem('Advisor Name');
    const demoValue = localStorage.getItem('Previous Demo Experience?');
    
    console.log('initAdvisorSelector - advisorID:', advisorID);
    
    // FIX: If "Yes", we use Demo Code now, so do NOT show the advisor selector
    if (demoValue === 'Yes') {
        $('.jsc-advisor-select').addClass('d-none');
    }
    // Only show if we have an ID but Demo is NOT "Yes" (e.g. Referral or "No" path)
    else if (advisorID && advisorID !== '-') {
        if ($('.jsc-advisor-select').length && $('.jsc-advisor-select').hasClass('d-none')) {
            console.log('Showing advisor selector on page load');
            $('.jsc-advisor-select').removeClass('d-none');
        }
    }
}
// start: remove customer update error tag
removeProfileUpdateError = () =>{
    var isTriggerRemoveTag = $('#trigger-remove-error').length;
  
    if (isTriggerRemoveTag) {
      var tag_val = $('#trigger-remove-error').val();
      var customer_id = $('#trigger-remove-error').attr('data-id');
    //   alert('tag_val: ' + tag_val + ' id: ' + customer_id)
      let _data = {
        tagsToRemove: tag_val,
        id: customer_id
      };
      // Legacy Mechanic URL — NOT in Settings → Mechanic webhooks (no admin row).
      // Topic user/custom/remove_tags.
      $.ajax({
        url: 'https://webhooks.mechanic.dev/f2855272-c9b5-4af1-9620-544149e327e7', // user/custom/remove_tags
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
      }).done(function () {
        
      });
    }
}
// end: remove customer update error tag
// start: onload loader
onLoadLoader = () => {
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    $(window).on('load', function() {
        setTimeout(function() {
            $loader.hide();
        }, 2000);
    });
}
// end: onload loader
// start: tm4u
onloadTm4u = () => {
    assignTm4uLocalStorage();
    redirectTm4uStep2Page();
    // resetDuplicatedTag();
}
getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}
assignTm4uLocalStorage = () => {
    const tm4uValue = getQueryParam("tm4u");
    if (tm4uValue === "true") {
        localStorage.setItem("tm4u", tm4uValue);
    }

    const comingFrom = getQueryParam("from");
    if (comingFrom === "newcomer-step-2" || comingFrom == "newcomer-owned") {
        localStorage.setItem("tm4u-redirect-link", comingFrom);
    }
}
redirectTm4uStep2Page = () =>{
    setTimeout(() => {
        var sp = window.theme.urls.storePathname();
        if (sp === '/pages/advisor-page' || sp === '/account' || sp === '/') {
            if (localStorage.getItem("tm4u") === "true" && localStorage.getItem("tm4u-redirect-link") != "") {
                localStorage.removeItem("tm4u");
                window.location.href = window.theme.urls.toStoreUrl('pages/' + localStorage.getItem("tm4u-redirect-link"));
            }
        }
    }, 900);
}
$(document).on('focus input', '#tm4u_nric_verify', function () {
    const el = this;
    el.value = el.value.replace(/[^\d-]/g, '');
    limitInput(el, 15);
});

tm4uNricDigitsOnly = (value) => String(value || '').replace(/\D/g, '');

isTm4uNricValidForCountry = (rawValue, country) => {
    const trimmed = String(rawValue || '').trim();
    if (!trimmed) return false;
    const digits = tm4uNricDigitsOnly(trimmed);
    const c = String(country || '').trim();
    if (!digits) return false;
    if (c === 'Belgium') return isBelgianNationalRegisterNumberValid(digits);
    if (c === 'Netherlands') return isDutchBsnValid(digits);
    if (c === 'Luxembourg') return isLuxembourgNationalIdValid(digits);
    return false;
};

belgianNationalRegisterChecksumExpected = (nineDigitStr) => {
    const n = Number(nineDigitStr);
    if (!Number.isFinite(n)) return null;
    const mod = n % 97;
    const check = 97 - mod;
    return String(check).padStart(2, '0');
};

tm4uIsUtcCalendarDateValid = (year, month, day) => {
    if (month < 1 || month > 12 || day < 1 || day > 31) return false;
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
};

isBelgianNationalRegisterNumberValid = (digits) => {
    if (digits.length !== 11) return false;
    const yy = parseInt(digits.slice(0, 2), 10);
    const mm = parseInt(digits.slice(2, 4), 10);
    const dd = parseInt(digits.slice(4, 6), 10);
    if (mm < 1 || mm > 12) return false;
    const y19 = 1900 + yy;
    const y20 = 2000 + yy;
    const dateOk19 = tm4uIsUtcCalendarDateValid(y19, mm, dd);
    const dateOk20 = tm4uIsUtcCalendarDateValid(y20, mm, dd);
    if (!dateOk19 && !dateOk20) return false;

    const first9 = digits.slice(0, 9);
    const check = digits.slice(9, 11);
    const expected19 = belgianNationalRegisterChecksumExpected(first9);
    const expected20 = belgianNationalRegisterChecksumExpected(`2${first9}`);
    if (expected19 == null || expected20 == null) return false;

    const matches19 = check === expected19;
    const matches20 = check === expected20;
    if (!matches19 && !matches20) return false;

    if (matches19 && matches20) {
        if (dateOk19 && !dateOk20) return true;
        if (dateOk20 && !dateOk19) return true;
        return false;
    }

    if (matches19) return dateOk19;
    return dateOk20;
};

isDutchBsnValid = (digits) => {
    if (!/^\d+$/.test(digits)) return false;
    let d = digits;
    if (d.length === 8) d = d.padStart(9, '0');
    if (d.length !== 9) return false;
    if (/^(\d)\1{8}$/.test(d)) return false;
    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += (9 - i) * parseInt(d[i], 10);
    }
    sum -= parseInt(d[8], 10);
    return sum % 11 === 0;
};

luxembourgIso7064Mod89CheckFrom11Digits = (elevenDigitStr) => {
    let n = 0;
    for (let i = 0; i < elevenDigitStr.length; i++) {
        const digit = parseInt(elevenDigitStr[i], 10);
        if (!Number.isFinite(digit)) return null;
        n = (n * 10 + digit) % 89;
    }
    const check = 89 - (n % 89);
    return String(check).padStart(2, '0');
};

isLuxembourgNationalIdValid = (digits) => {
    if (digits.length !== 13) return false;
    const y = parseInt(digits.slice(0, 4), 10);
    const m = parseInt(digits.slice(4, 6), 10);
    const day = parseInt(digits.slice(6, 8), 10);
    if (y < 1800 || y > 2100 || m < 1 || m > 12 || day < 1 || day > 31) return false;
    if (!tm4uIsUtcCalendarDateValid(y, m, day)) return false;

    const body11 = digits.slice(0, 11);
    const expectedCheck = luxembourgIso7064Mod89CheckFrom11Digits(body11);
    if (expectedCheck == null) return false;
    return digits.slice(11, 13) === expectedCheck;
};

showConfirmation = () =>{
    let nric = $('#tm4u_nric_verify').val();
    console.log('nric: ', nric, ' validate pass: ', `${/^\d{10}$/.test(nric)}`);
    if (/^\d{10}$/.test(nric)) {
        $('#confirm-nric').text(nric);
        $('#jsc-tm4u-overlay').css('display', 'block');
        $('#jsc-tm4u-popup').show();
    } else {
        $('#nric-digit-error').show();
    }
}
closeConfirmation = () =>{
    $('#jsc-tm4u-overlay').css('display', 'none');
    $('#jsc-tm4u-popup').hide();
}
// verifyNRIC = (e,id) =>{
//     const $loader = $('.jsc-loader-overlay');
//     let mechanic_webhook = 'https://webhooks.mechanic.dev/e4298d38-9e85-47ca-a79c-92547c8befe9';
//     let nric = $('#tm4u_nric_verify').val();
//     let this_customer_id = `gid://shopify/Customer/${id}`;
//     let $data = {
//         nric: nric,
//         gid: this_customer_id
//     };

//     $.ajax({
//         url: mechanic_webhook, //user/verify/nric
//         method: "POST",
//         headers: {
//             "content-type": "application/json",
//         },
//         data: JSON.stringify($data),
//         success: function(response) {
//             console.log("Success:", response);
//             // $loader.append(`<p class="verify-load">Hang tight! We're verifying your details—this might take a moment. No need to refresh, we've got this! 🚀</p>`);
//             $loader.show();
//             setTimeout(() => {
//                 location.reload();
//             }, 8000);
//         },
//         error: function(xhr, status, error) {
//             console.error("Error:", xhr.responseText);
//             // alert("An error occurred: " + xhr.responseText);
//         }
//     });
// }
// resetDuplicatedTag = () =>{
//     let reset_duplicate_tag = $('#reset_duplicated_tag');
//     if (reset_duplicate_tag.length) {
//         let id = reset_duplicate_tag.val();
//         let mechanic_webhook = 'https://webhooks.mechanic.dev/d583fd4f-7118-46e2-a6cb-34fadf12a122';
//         let this_customer_id = `gid://shopify/Customer/${id}`;
//         let $data = {
//             gid: this_customer_id,
//         };

//         $.ajax({
//             url: mechanic_webhook, //user/verify/reset
//             method: "POST",
//             headers: {
//                 "content-type": "application/json",
//             },
//             data: JSON.stringify($data)
//         });
//     }
// }
showNewcomerProgramDetailsConfirmation = (button, customerId, isHappyCustomerAdvisorProgram) => {
    console.log('isHappyCustomerAdvisorProgram: ', isHappyCustomerAdvisorProgram);
    const $nric = $('#tm4u_nric_verify').length ? $('#tm4u_nric_verify').val().trim() : '';
    const $addr1 = $('#tm4u_address_1').length ? $('#tm4u_address_1').val().trim() : '';
    const $addr2 = $('#tm4u_address_2').length ? $('#tm4u_address_2').val().trim() : '';
    const $city = $('#tm4u_city').length ? $('#tm4u_city').val().trim() : '';
    const $postalCode = $('#tm4u_postal_code').length ? $('#tm4u_postal_code').val().trim() : '';
    const $country = $('#tm4u_country').length ? $('#tm4u_country').val().trim() : '';
    const $serial = $('#tm4u_serial_number').length ? $('#tm4u_serial_number').val().trim() : '';

    console.log('nric: ', $nric, ' addr1: ', $addr1, ' city: ', $city, ' postalCode: ', $postalCode, ' country: ', $country, ' serial: ', $serial);

    const $errUl = $('.jsc-tm4u-form-errors');
    $errUl.find('li').hide();

    const allRequired =
        $nric != '' &&
        $addr1 != '' &&
        $city != '' &&
        $postalCode != '' &&
        $country != '' &&
        (isHappyCustomerAdvisorProgram ? $serial != '' : true);

    let isFormValid = true;

    if (!allRequired) {
        $('#newcomer-form-input-error').show();
        isFormValid = false;
    }

    // if ($country && !isTm4uNricValidForCountry($nric, $country)) {
    //     $('#nric-digit-error').show();
    //     isFormValid = false;
    // }

    if (!isFormValid) {
        $errUl.css('display', 'block');
        return;
    }

    $errUl.hide();

    const $confirmDetails = $('.jsc-tm4u-confirm-details');
    if (!$confirmDetails.length) return;

    const parts = [];
    const s2a = vorwerkStep2aStrings();
    if ($nric != '') {
      parts.push(vwConfirmHtml(
        s2a.confirmNric,
        'Is your National Identification Number correct as shown:',
        'confirm-nric'
      ));
    }
    const hasAddress =
      $addr1 != '' || $addr2 != '' || $city != '' || $postalCode != '' || $country != '';
    if (hasAddress) {
      parts.push(vwConfirmHtml(
        s2a.confirmAddress,
        'Is your address correct as shown:',
        'confirm-address'
      ));
    }
    if ($serial != '') {
      parts.push(vwConfirmHtml(
        s2a.confirmSerial,
        'Is your serial number correct as shown:',
        'confirm-serial-number'
      ));
    }

    $confirmDetails.html(parts.join(''));

    if ($nric != '') $('#confirm-nric').text($nric || '—');
    if (hasAddress) {
      const addrParts = [];
      if ($addr1 != '') addrParts.push(($addr1).trim());
      if ($addr2 != '') addrParts.push(($addr2).trim());
      if ($city != '') addrParts.push(($city).trim());
      if ($postalCode != '') addrParts.push(($postalCode).trim());
      if ($country != '') addrParts.push(($country).trim());
      $('#confirm-address').text(addrParts.filter(Boolean).join(', ') || '—');
    }
    if ($serial != '') $('#confirm-serial-number').text(($serial).trim() || '—');

    $('#jsc-tm4u-overlay').css('display', 'block');
    $('#jsc-tm4u-popup').show();
};

closeNewcomerProgramDetailsConfirmation = () => {
    $('#jsc-tm4u-overlay').css('display', 'none');
    $('#jsc-tm4u-popup').hide();
};

getCountryCodeFromName = (countryName) => {
    const map = {
        belgium: 'BE',
        belgique: 'BE',
        belgië: 'BE',
        belgie: 'BE',
        be: 'BE',
        netherlands: 'NL',
        nederland: 'NL',
        nl: 'NL',
        luxembourg: 'LU',
        lu: 'LU',
    };
    const key = String(countryName || '').trim().toLowerCase();
    return map[key] || '';
};

setNewcomerShippingCartAttributes = ({ address1, address2, city, postalCode, country }) => {
    const customerInfo = window.theme && window.theme.customerInfo;
    return CartJS.setAttributes({
        address1: address1 || '',
        address2: address2 || '',
        city: city || '',
        provinceCode: '',
        zip: postalCode || '',
        countryCode: getCountryCodeFromName(country),
        'shipping-firstName': (customerInfo && customerInfo.firstName) || '',
        'shipping-lastName': (customerInfo && customerInfo.lastName) || '',
    });
};

verifyNewcomerProgramDetails = (e, customerId, customerEmail, customerTags) => {
    const $loader = $('.jsc-loader-overlay');
    const retoolWebhook = 'https://vorwerkbenelux.retool.com/url/verify-newcomer-program-form-prod';
    const customerGid = `gid://shopify/Customer/${customerId}`;
    const getVal = (selector) => {
        const $el = $(selector);
        return $el.length ? ($el.val() || '').trim() : '';
    };
    const payload = {
        customer_id: customerGid,
        customer_email: customerEmail,
        customer_tags: customerTags,
        tm4u_nric: getVal('#tm4u_nric_verify').replace(/\D/g, ''),
        tm4u_address_1: getVal('#tm4u_address_1'),
        tm4u_address_2: getVal('#tm4u_address_2'),
        tm4u_city: getVal('#tm4u_city'),
        tm4u_postal_code: getVal('#tm4u_postal_code'),
        tm4u_country: getVal('#tm4u_country'),
        tm4u_serial_number: getVal('#tm4u_serial_number')
    };
    const errorContainer = document.querySelector(".jsc-tm4u-form-errors");
    if (errorContainer) {
        errorContainer.querySelectorAll("li")
            .forEach(el => el.style.display = "none");

        errorContainer.style.display = "none";
    }

    closeNewcomerProgramDetailsConfirmation();
    $loader.show();
    $.ajax({
        url: retoolWebhook,
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        data: JSON.stringify(payload),
        success: function (response) {
            console.log('response: ', response);
            if (response && response.status === 'fail') {
                const message = response.message;
                const errorIds = typeof message === 'string' ? message.split(',').map((id) => id.trim()).filter(Boolean) : [];
                const container = document.querySelector('.jsc-tm4u-form-errors');
                if (container) {
                    let showError = false;
                    for (const id of errorIds) {
                        const el = container.querySelector(`#${id}`);
                        if (el) {
                            el.style.display = 'list-item';
                            showError = true;
                        }
                    }
                    const duplicateErrors = [
                        "serial-number-registered-error",
                        "nric-duplicate-error",
                        "address-duplicate-error"
                    ];
                    if (duplicateErrors.some(err => errorIds.includes(err))) {
                        document.getElementById("never-registered-error").style.display = "list-item";
                    }
                    if (showError) {
                        container.style.display = 'block';
                    }
                }
                $loader.hide();
                return;
            }
            const reloadAfterCartUpdate = () => {
                $loader.hide();
                location.reload();
            };

            if (typeof CartJS !== 'undefined') {
                const fallbackTimer = setTimeout(reloadAfterCartUpdate, 3000);
                $(document).one('cart.requestComplete', () => {
                    clearTimeout(fallbackTimer);
                    reloadAfterCartUpdate();
                });
                setNewcomerShippingCartAttributes({
                    address1: payload.tm4u_address_1,
                    address2: payload.tm4u_address_2,
                    city: payload.tm4u_city,
                    postalCode: payload.tm4u_postal_code,
                    country: payload.tm4u_country,
                });
                return;
            }

            setTimeout(reloadAfterCartUpdate, 1000);
        },
        error: function (xhr) {
            const msg = (xhr.responseJSON && (xhr.responseJSON.error_message || xhr.responseJSON.message)) || xhr.responseText || vorwerkStep2aStrings().verificationFailed || 'Verification failed. Please try again or contact support.';
            $('#never-registered-error').text(msg).show();
            $loader.hide();
        }
    });
};
submitstep2b = (e) =>{
    // click upload NRIC
    $('.cf-submit-form').click();
    
    setTimeout(() => {
        if ($('.cf-step-invalid').length) {
            $('html, body').animate({
                scrollTop: $('.cf-step-invalid').first().offset().top - 120
            }, 500);            
        } else {
            if ($('.jsc-accepts_policy').length === $('.jsc-accepts_policy:checked').length) {
                $('#accepts_policy_error').hide();
                updatePdpaAdvisor(e,true);
                $('html, body').animate({
                    scrollTop: $('.step2b').first().offset().top - 120
                }, 500);
            } else {
                $('#accepts_policy_error').show();
            }
        }
    }, 1200);
}
// end: tm4u
// start: download pdf (print)
triggerDownloadPdf = (e, contentId) => {
    const _this = $(e);
    let $content = $('#' + contentId);
    let divContents = $content.length ? $content.html() : '';

    if (divContents !== '') {
        let styleSheet1 = _this?.attr('data-css1') || '';
        let styleSheet2 = _this?.attr('data-css2') || '';
        let printWindow = window.open('', '', 'height=800,width=800');

        let htmlContent = '<html><head><title>Print E-Business Card</title>';
        if (styleSheet1 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet1}" preload>`;
        }
        if (styleSheet2 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet2}" preload>`;
        }
        htmlContent += `</head><body><div class="page-width page-content">${divContents}</div></body></html>`;

        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        setTimeout(function () {
            printWindow.print();
        }, 1000);
    }
}
// end: download pdf (print)


// start: implement overlay when menu dropdown is open
function toggleMegaMenuOverlay() {
    const detailsList = document.querySelectorAll('.site-nav__details');
    const headerElements = document.querySelectorAll('.site-header__element');
    const mainContent = document.querySelector('.main-content');

    if (detailsList.length === 0 || headerElements.length === 0 || !mainContent) return;

    // Check if ANY dropdown is open
    const isAnyOpen = Array.from(detailsList).some(details => details.hasAttribute('open'));

    if (isAnyOpen) {
      // Full-page blur overlay inside .main-content
      if (!document.querySelector('.jsc-blurred-overlay')) {
        const overlay = document.createElement('div');
        overlay.classList.add('jsc-blurred-overlay');
        mainContent.appendChild(overlay);
      }

      // Light overlays only for first 2 header elements
      headerElements.forEach((headerElement, index) => {
        if (index < 2 && !headerElement.querySelector('.jsc-light-overlay')) {
          const lightOverlay = document.createElement('div');
          lightOverlay.classList.add('jsc-light-overlay');
        //   headerElement.style.position = 'relative';
          headerElement.appendChild(lightOverlay);
        }
      });
  
      document.addEventListener('click', handleOutsideClick);
    } else {
      removeMegaMenuOverlay();
    }
}
  
function removeMegaMenuOverlay() {
    document.querySelector('.jsc-blurred-overlay')?.remove();
    document.querySelectorAll('.jsc-light-overlay').forEach(el => el.remove());

    // Close ALL open details
    document.querySelectorAll('.site-nav__details[open]').forEach(details => {
        details.removeAttribute('open');
    });

    document.removeEventListener('click', handleOutsideClick);
}
  
function handleOutsideClick(event) {
    const detailsList = document.querySelectorAll('.site-nav__details');
    if ([...detailsList].every(details => !details.contains(event.target))) {
    removeMegaMenuOverlay();
    }
}

// --- New close button logic ---
const closeIcons = document.querySelectorAll('.jsc-close-icon');
if (closeIcons.length > 0) {
  closeIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      e.preventDefault();
      removeMegaMenuOverlay();
    });
  });
}

// Observe ALL details elements
const targets = document.querySelectorAll('.site-nav__details');
targets.forEach(target => {
    const observer = new MutationObserver(toggleMegaMenuOverlay);
    observer.observe(target, { attributes: true, attributeFilter: ['open'] });
});
// end: implement overlay when menu dropdown is open

//start: disable background scrolling when mobile menu is open
toggleBodyScroll = () => {
    $(document).on('click', '.mobile-nav-trigger', function () {
        if ($('.jsc-mobile-nav-bg-color').hasClass('is-active')) {
          $('body').addClass('no-scroll');
        } else {
          $('body').removeClass('no-scroll');
        }
    });
}
//end: disable background scrolling when mobile menu is open

//start: tax invoice
fullTaxInvoice = async (e) => {
  const $this = $(e);
  const $val = $this.val();
  // Clear any existing error messages when user makes a selection
  $('.jsc-tax-invoice-error-message').remove();

  const tx = vorwerkTaxStrings();
  const $companyHtml = `
    <div class="jsc-full-tax-company__container">
        <label for="jsc-full-tax-company-name">${tx.companyNameLabel || ''} <span class="tax-required"></span></label>
        <input id="jsc-full-tax-company-name" type="text" name="attributes[Company Name]" value="">
        <label for="jsc-full-tax-company-registration-no">${tx.companyRegistrationLabel || ''} <span class="tax-required"></span></label>
        <input id="jsc-full-tax-company-registration-no" type="number" name="attributes[Company Registration No]" value="">
        <p style="color: red;">${tx.companyPolicyNote || ''}</p>
        <div class="jsc-form-group">
            <input type="checkbox" id="full-tax-invoice-policy" name=attributes[Tax Policy]" value="agreed" required class="jsc-form-group-input">
            <label for="full-tax-invoice-policy" class="jsc-form-group-input">${tx.taxPolicyLabel || ''} <span class="tax-required"></span></label>
        </div>
        <div class="jsc-tax-invoice-save-btn" onclick="saveCartAttr(this)">${tx.saveToUpdate || ''}</div>
    </div>
  `;

  const $personalHtml = `
    <div class="jsc-full-tax-personal__container">
        <p id="jsc-invoice-warning" style="color: red; font-size: 12px; margin-top: 2px; display: block; width: 100%;">${tx.personalPolicyNote || ''}</p>
        <div class="jsc-form-group">
            <input type="checkbox" id="full-tax-invoice-policy" name=attributes[Tax Policy]" value="agreed" required class="jsc-form-group-input">
            <label for="full-tax-invoice-policy" class="jsc-form-group-input">${tx.taxPolicyLabel || ''} <span class="tax-required"></span></label>
        </div>
        <div class="jsc-tax-invoice-save-btn" onclick="saveCartAttr(this)">${tx.saveToUpdate || ''}</div>
    </div>
  `;

  const $mobileCarrierHtml = `
    <div class="jsc-full-tax-mobile-carrier__container">
        <label for="jsc-mobile-carrier-no-mandatory">${tx.mobileCarrierLabel || ''}<span class="tax-required"></span></label>
        <input id="jsc-mobile-carrier-no-mandatory" type="text" name="attributes[Mobile Carrier No]" value="" placeholder="${tx.mobileCarrierPlaceholder || ''}">
        <p id="jsc-invoice-warning" style="color: red; font-size: 12px; margin-top: 2px; display: block; width: 100%;">${tx.personalPolicyNote || ''}</p>
        <div class="jsc-form-group">
            <input type="checkbox" id="full-tax-invoice-policy" name=attributes[Tax Policy]" value="agreed" required class="jsc-form-group-input">
            <label for="full-tax-invoice-policy" class="jsc-form-group-input">${tx.taxPolicyLabel || ''} <span class="tax-required"></span></label>
        </div>
        <div class="jsc-tax-invoice-save-btn" onclick="saveCartAttr(this)">${tx.saveToUpdate || ''}</div>
    </div>
  `;

  // Clean UI first
  $('.jsc-full-tax-company__container').remove();
  $('.jsc-full-tax-personal__container').remove();
  $('.jsc-full-tax-mobile-carrier__container').remove();

  if ($val === 'Company') {
    $('.jsc-tax-invoice').append($companyHtml);

    // Remove Personal and Mobile Carrier No related cart attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Mobile Carrier No": ""
        }
      })
    });

  } else if ($val === 'Personal') {
    $('.jsc-tax-invoice').append($personalHtml);

    // Remove Company-related cart attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Company Name": "",
          "Company Registration No": "",
          "Tax Policy": "",
          "Mobile Carrier No": ""
        }
      })
    });

  } else if ($val === 'Mobile Carrier No') {
    $('.jsc-tax-invoice').append($mobileCarrierHtml);

    // Remove Company-related cart attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Company Name": "",
          "Company Registration No": "",
          "Tax Policy": ""
        }
      })
    });

  } else {
    // reset — clear all attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Mobile Carrier No": "",
          "Company Name": "",
          "Company Registration No": "",
          "Tax Policy": ""
        }
      })
    });
  }
};
const saveCartAttr = async (button) => {
    // If button is provided, normalize to jQuery object
    const $this = button ? $(button) : null;
    const $container = $this?.closest(".jsc-tax-invoice") || $(".jsc-tax-invoice");
    const tx = vorwerkTaxStrings();
    const g = vorwerkGeneralStrings();

    if (!$container.length) {
      console.log("⚠️ Tax invoice container not found.");
      return true; // No tax invoice section = skip validation
    }

    const $loader = $(".jsc-loader-overlay");
    $loader.show();

    const attributes = {};
    let passValidation = true;

    const $taxInvoiceType = $container.find('input[name="attributes[Tax Invoice for Legal Compliance]"]:checked');

    // Remove old error messages first
    $container.find(".jsc-tax-invoice-error-message").remove();

    if ($taxInvoiceType.length > 0 && $taxInvoiceType.val() !== "") {
      attributes["Tax Invoice for Legal Compliance"] = $taxInvoiceType.val();

      if ($taxInvoiceType.val() === "Company") {
        const $companyName = $container.find("#jsc-full-tax-company-name");
        const $companyRegistrationNo = $container.find("#jsc-full-tax-company-registration-no");

        // Company Name
        if ($companyName.length > 0 && $companyName.val() !== "") {
          attributes["Company Name"] = $companyName.val();
        } else {
          passValidation = false;
          $container.append(`<div class="jsc-tax-invoice-error-message">${tx.companyNameEmptyError || 'Please fill in the company name.'}</div>`);
        }

        // Company Registration No
        if ($companyRegistrationNo.length > 0 && $companyRegistrationNo.val() !== "") {
          const companyRegistrationNoTrim = $companyRegistrationNo.val().trim();
          if (/^\d{8}$/.test(companyRegistrationNoTrim)) {
            attributes["Company Registration No"] = $companyRegistrationNo.val();
          } else {
            passValidation = false;
            $container.append(`<div class="jsc-tax-invoice-error-message">${tx.companyRegistrationNoInvalidError || 'Invalid company registration no.'}</div>`);
          }
        } else {
          passValidation = false;
          $container.append(`<div class="jsc-tax-invoice-error-message">${tx.companyRegistrationNoEmptyError || 'Please fill in the company registration no.'}</div>`);
        }

      } else if ($taxInvoiceType.val() === "Mobile Carrier No") {
        const $mobileCarrierNo = $container.find("#jsc-mobile-carrier-no-mandatory");

        if ($mobileCarrierNo.length > 0 && $mobileCarrierNo.val() !== "") {
          const mobileCarrierNoTrim = $mobileCarrierNo.val().trim();
          if (/^.{8}$/.test(mobileCarrierNoTrim)) {
            attributes["Mobile Carrier No"] = $mobileCarrierNo.val();
          } else {
            passValidation = false;
            $container.append(`<div class="jsc-tax-invoice-error-message">${tx.mobileCarrierNoInvalidError || 'Invalid mobile carrier no.'}</div>`);
          }
        } else {
          passValidation = false;
          $container.append(`<div class="jsc-tax-invoice-error-message">${tx.mobileCarrierNoEmptyError || 'Please fill in the mobile carrier no.'}</div>`);
        }
      }

      // Tax Policy Checkbox
      const $taxPolicy = $container.find("#full-tax-invoice-policy");
      if ($taxPolicy.length > 0 && !$taxPolicy.is(':checked')) {
        passValidation = false;
        $container.append(`<div class="jsc-tax-invoice-error-message">${tx.taxPolicyRequiredError || 'Please agree to the Tax Policy.'}</div>`);
      } else if ($taxPolicy.length > 0 && $taxPolicy.is(':checked')) {
        attributes["Tax Policy"] = $taxPolicy.val();
      }
    } else {
      passValidation = false;
      $container.append(`<div class="jsc-tax-invoice-error-message">${tx.taxInvoiceTypeEmptyError || 'Please select a tax invoice type.'}</div>`);
    }

    if (passValidation) {
      try {
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes }),
        });

        const updatedCart = await res.json();
        console.log("✅ Cart attributes updated:", updatedCart);
        await addTaxInvoiceInfoAtLineItemProperties();

        // Optional feedback if button exists
        if ($this) {
          $this.text(tx.savedLabel || 'Saved!').prop("disabled", true);
          setTimeout(() => {
            $this.text(tx.saveToUpdate || 'Save to update').prop("disabled", false);
          }, 2000);
        }

      } catch (err) {
        console.error("❌ Failed to update cart attributes:", err);
        alert(g.genericTryAgain || "Something went wrong. Please try again.");
        passValidation = false;
      } finally {
        $loader.hide();
      }
    } else {
      $loader.hide();
    }

    return passValidation;
};
getTaxAttr = async () =>{
    const $loader = $('.jsc-loader-overlay');
    $loader.show();
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const cart_attr_obj = cart.attributes;
    console.log('getCartAttr in getTaxAttr(): ',cart_attr_obj);
    if (cart.attributes['Tax Invoice for Legal Compliance']) {
        if (cart_attr_obj['Tax Invoice for Legal Compliance']) {
            const taxType = cart_attr_obj['Tax Invoice for Legal Compliance'];
            let id_key = taxType.toLowerCase();
            // Handle special case for "Mobile Carrier No"
            if (taxType === 'Mobile Carrier No') {
                id_key = 'mobile-carrier';
            }
            console.log('id_key',id_key);
            $(`#jsc-full-tax-${id_key}`).prop('checked', true).trigger('change');
        }
        if ($('#jsc-full-tax-company-name').length != 0) {
            $('#jsc-full-tax-company-name').val(cart_attr_obj['Company Name']);
        }
        if ($('#jsc-full-tax-company-registration-no').length != 0) {
            $('#jsc-full-tax-company-registration-no').val(cart_attr_obj['Company Registration No']);
        }
        if ($('#full-tax-invoice-policy').length != 0 && cart_attr_obj['Tax Policy'] === 'agreed') {
            $('#full-tax-invoice-policy').prop('checked', true);
        }
        if ($('#jsc-mobile-carrier-no-mandatory').length != 0) {
            $('#jsc-mobile-carrier-no-mandatory').val(cart_attr_obj['Mobile Carrier No']);
        }
    } else if (window.CustomerTaxInvoice) {
        console.log('window.CustomerTaxInvoice in getTaxAttr(): ',window.CustomerTaxInvoice);
        if (window.CustomerTaxInvoice.company_name && window.CustomerTaxInvoice.company_name != '' && window.CustomerTaxInvoice.company_registration_no && window.CustomerTaxInvoice.company_registration_no != '') {
            $(`#jsc-full-tax-company`).click();
            $('#jsc-full-tax-company-name').val(window.CustomerTaxInvoice.company_name);
            $('#jsc-full-tax-company-registration-no').val(window.CustomerTaxInvoice.company_registration_no);
        } else if (window.CustomerTaxInvoice.mobile_carrier_no && window.CustomerTaxInvoice.mobile_carrier_no != '') {
            $(`#jsc-full-tax-mobile-carrier`).click();
            $('#jsc-mobile-carrier-no-mandatory').val(window.CustomerTaxInvoice.mobile_carrier_no);
        }
    }
    $loader.hide();
}
$(document).on("focus input", "#jsc-full-tax-company-registration-no", function () {
    let val = $(this).val().replace(/\D/g, "");
    if (val.length > 8) val = val.slice(0, 8);
    $(this).val(val);
});
$(document).on("input", "#jsc-mobile-carrier-no-mandatory", function () {
    let val = $(this).val();

    // ✅ Remove spaces only (symbols, letters, numbers are allowed)
    val = val.replace(/\s/g, "");

    // ✅ Force first character to be "/"
    if (!val.startsWith("/")) {
      val = "/" + val.replace(/^\//g, "");
    }

    // ✅ Enforce EXACT total length = 8 (1 "/" + 7 others)
    val = val.slice(0, 8);

    $(this).val(val);
});
//end: tax invoice
//start: show disclaimer text for TM and KS product logic
hoverATCbutton = () => {
    $('.jsc-hover-atc-button').hover(
        function () {
            // on hover in
            var $disclaimer_text = $(this).siblings('.jsc-disclaimer-text-for-tm-and-ks');
            $disclaimer_text.fadeIn(200);
        },
        function () {
            // on hover out
            var $disclaimer_text = $(this).siblings('.jsc-disclaimer-text-for-tm-and-ks');
            $disclaimer_text.fadeOut(200);
        }
    );
}
//end: show disclaimer text for TM and KS product logic
// start: show popup when button with mixing restriction is clicked
$(document).on('click', 'button[data-show-mixing-popup="true"]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const sectionId = $this.data('section-id');
    console.log('sectionId', sectionId);

    if (!sectionId) return;

    const popup = $(`#jsc-mixing-popup-${sectionId}`);
    console.log('popup', popup);
    if (!popup.length) return;

    const closeButton = popup.find('.jsc-mixing-popup-close');
    const overlay = popup.find('.jsc-mixing-popup-overlay');
    const continueButton = popup.find('.jsc-continue-without-adding');
    const clearCartButton = popup.find('.jsc-clear-cart-and-add');

    console.log('closeButton', closeButton);
    console.log('overlay', overlay);

    popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    const closePopup = () => {
        popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
    }

    if (closeButton.length > 0) {
        closeButton.on('click', function(ce) {
            ce.preventDefault();
            ce.stopPropagation();
            closePopup();
        });
    }

    if (overlay.length > 0) {
        overlay.on('click', function(oe) {
            oe.preventDefault();
            oe.stopPropagation();
            closePopup();
        });
    }

    if (continueButton.length > 0) {
        continueButton.on('click', function(ctne) {
            ctne.preventDefault();
            ctne.stopPropagation();
            closePopup();
        });
    }

    if (clearCartButton.length > 0) {
        clearCartButton.on('click', function(ccte) {
            ccte.preventDefault();
            ccte.stopPropagation();
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                }
            })
            .then(response => response.json())
            .then(() => {
                // Now submit the form to add the current item
                $this.removeAttr('data-show-mixing-popup');
                $this.trigger('click');
            })
            .catch(error => {
                console.error('Error clearing cart:', error);
                alert(vorwerkGeneralStrings().cartRequestError || 'There was an error processing your request. Please try again.');
            });
        });
    }
});

// end: show popup when button with mixing restriction is clicked
// start: show popup when button with quantity limit restriction is clicked
$(document).on('click', 'button[data-show-quantity-limit-popup="true"]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const sectionId = $this.data('section-id');
    console.log('sectionId', sectionId);

    if (!sectionId) return;

    const popup = $(`#jsc-quantity-limit-popup-${sectionId}`);
    console.log('popup', popup);
    if (!popup.length) return;

    const closeButton = popup.find('.jsc-mixing-popup-close');
    const overlay = popup.find('.jsc-mixing-popup-overlay');
    const continueButton = popup.find('.jsc-continue-without-adding');

    console.log('closeButton', closeButton);
    console.log('overlay', overlay);

    popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    const closePopup = () => {
        popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
    }

    if (overlay.length > 0) {
        overlay.on('click', function(oe) {
            oe.preventDefault();
            oe.stopPropagation();
            closePopup();
        });
    }

    if (continueButton.length > 0) {
        continueButton.on('click', function(ctne) {
            ctne.preventDefault();
            ctne.stopPropagation();
            closePopup();
        });
    }
});
// end: show popup when button with quantity limit restriction is clicked

/* ========================================================
   CART VALIDATION LOCK (Advisor/Demo Code + Terms -> Checkout)
   ======================================================== */
   function initCartValidationLock() {
    const $checkoutBtn = $('#jsc-checkout-btn');
    const $termsCheckbox = $('#CartTerms');
    
    const disabledStyle = {
        'opacity': '0.5',
        'pointer-events': 'none', 
        'cursor': 'not-allowed',
        'background-color': '#ccc', 
        'border-color': '#ccc'
    };
    
    const enabledStyle = {
        'opacity': '1',
        'pointer-events': 'auto',
        'cursor': 'pointer',
        'background-color': '', 
        'border-color': ''
    };

    function checkCartState() {
        // 1. Check Advisor Selection (for "No" path)
        const advisorVal = $('#search-advisor').val();
        const hasAdvisor = (advisorVal && advisorVal !== '' && advisorVal !== '-');

        // 2. Check Demo Code (for "Yes" path)
        const demoCodeVal = $('#demo-code-input').val();
        const hasDemoCode = (demoCodeVal && demoCodeVal.trim() !== '');

        // 3. Check Terms
        const termsChecked = $termsCheckbox.is(':checked');

        // LOGIC: Enable button if (Has Advisor OR Has Demo Code OR Terms Checked)
        if (hasAdvisor || hasDemoCode || termsChecked) {
            $checkoutBtn.css(enabledStyle);
        } else {
            $checkoutBtn.css(disabledStyle);
        }
    }

    $termsCheckbox.on('change', checkCartState);
    $(document).on('input change', '#search-advisor, #demo-code-input', checkCartState);
    $('.demo-radio').on('change', function() {
        setTimeout(checkCartState, 200); 
    });

    checkCartState();
    setInterval(checkCartState, 500);
}

function syncBookingCheckoutBlock(cart) {
    document.querySelectorAll('#CartPageForm, .cart__drawer-form').forEach(function (form) {
        const ids = (form.getAttribute('data-booking-product-ids') || '').split(',').filter(Boolean);
        if (!ids.length) return;

        let blocked = form.getAttribute('data-booking-checkout-blocked') === 'true';
        if (cart && Array.isArray(cart.items)) {
            blocked = cart.items.some(function (item) {
                return ids.indexOf(String(item.product_id)) !== -1;
            });
            form.setAttribute('data-booking-checkout-blocked', blocked ? 'true' : 'false');
        }

        if (form.id === 'CartPageForm') {
            const overlay = document.getElementById('jsc-booking-checkout-overlay');
            const message = document.getElementById('jsc-booking-checkout-message');
            if (overlay) overlay.style.display = blocked ? '' : 'none';
            if (message) message.style.display = blocked ? '' : 'none';
        }

        const submitBtn = form.querySelector('button[name="checkout"]');
        if (submitBtn) {
            if (blocked) submitBtn.setAttribute('disabled', 'disabled');
            else submitBtn.removeAttribute('disabled');
        }
    });
}

$(document).ready(function() {
    initCartValidationLock();
    syncBookingCheckoutBlock(null);

    document.addEventListener('cart:updated', function (event) {
        syncBookingCheckoutBlock(event.detail && event.detail.cart);
    });

    // NEW: Auto-save Demo Code to Cart Attributes when user types
    $(document).on('change', '#demo-code-input', function() {
        const code = $(this).val();
        // 1. Save to Local Storage (so it persists on refresh)
        localStorage.setItem('Demo Code', code);
        
        // 2. Save to Shopify Cart Attributes immediately (so JSON updates)
        CartJS.setAttributes({
            "Demo Code": code
        });
    });
});